var map = {
	"./80c_icon.svg": 1876,
	"./Bitmap.svg": 1877,
	"./Gold_banner2.jpg": 4169,
	"./Gold_updated_banner.svg": 1878,
	"./Group 252.svg": 1879,
	"./Insurance.svg": 1880,
	"./Insurance_fisdom.svg": 1881,
	"./Insurance_myway.svg": 1882,
	"./MMTC-PAMP-offer.png": 3443,
	"./ORDivider.svg": 805,
	"./Vector.svg": 1883,
	"./Vector_2.svg": 1884,
	"./aadhar.png": 3444,
	"./accidental_death_icon.png": 3445,
	"./account.svg": 1885,
	"./account_already_exists.svg": 1886,
	"./add_bank_icn.svg": 1887,
	"./add_bank_icon.png": 3446,
	"./add_cart_icon.png": 3302,
	"./add_icon.svg": 1888,
	"./address_details_icon.svg": 958,
	"./address_icon.svg": 1889,
	"./alb.png": 3447,
	"./alert_icon.svg": 1149,
	"./amazon_pay.svg": 1006,
	"./amfi.svg": 1890,
	"./amfi_logo.svg": 1150,
	"./analyst.svg": 1891,
	"./analystpick.svg": 1892,
	"./annual_income_dark_icn.png": 3319,
	"./annual_income_icn.png": 3448,
	"./apply_now.svg": 1893,
	"./arrow.png": 3449,
	"./arrow_back.svg": 1151,
	"./arrow_down.svg": 1894,
	"./arrow_next.svg": 1152,
	"./arrow_right.svg": 1895,
	"./arrow_up.svg": 1896,
	"./arrow_up_grey.svg": 1897,
	"./arrw_down.svg": 1007,
	"./attach_button.svg": 1008,
	"./attention.svg": 1898,
	"./attention_icon.svg": 1009,
	"./attention_icon_new.svg": 1899,
	"./audio/success.mp3": 3581,
	"./auto_debit.png": 3450,
	"./back_arrow.svg": 1900,
	"./back_arrow_white.svg": 974,
	"./back_nav_bar_icon.png": 3320,
	"./back_nav_bar_icon.svg": 1901,
	"./back_nav_bar_icon_up.png": 3334,
	"./badge-error.svg": 1902,
	"./badge-success.svg": 975,
	"./badge-warning.svg": 1903,
	"./bank_icon@4x.png": 3451,
	"./bank_statement.svg": 1904,
	"./banks/HDF/2.png": 3335,
	"./banks/HDF/3.png": 3336,
	"./banks/HDF/4.png": 3337,
	"./banks/HDF/5.png": 3338,
	"./banks/ICI/2.png": 3339,
	"./banks/ICI/3.png": 3340,
	"./banks/ICI/4.png": 3341,
	"./banks/ICI/5.png": 3342,
	"./banks/KTB/1.png": 3343,
	"./banks/KTB/2.png": 3344,
	"./banks/KTB/3.png": 3345,
	"./banks/KTB/4.png": 3346,
	"./banks/KTB/5.png": 3347,
	"./banks/KTB/6.png": 3348,
	"./banks/SBI/2.png": 3349,
	"./banks/SBI/3.png": 3350,
	"./banks/SBI/4.png": 3351,
	"./banks/SBI/5.png": 3352,
	"./banks/SBI/6.png": 3353,
	"./banks/UTI/2.png": 3354,
	"./banks/UTI/3.png": 3355,
	"./banks/UTI/4.png": 3356,
	"./banks/UTI/5.png": 3357,
	"./baxa_new_logo.svg": 1010,
	"./bfdl_announcement_button.svg": 1905,
	"./bfdl_white_sdk_logo.svg": 1906,
	"./bg.svg": 1907,
	"./bg_waves.svg": 1908,
	"./bg_waves_full_screen.svg": 1909,
	"./bg_waves_fund.svg": 1910,
	"./blue_checked.svg": 1911,
	"./blue_unchecked.svg": 1912,
	"./bom.png": 3452,
	"./bom.svg": 1913,
	"./bom_bank.svg": 1914,
	"./bombay_stock_exchange_logo.svg": 1153,
	"./bond_icon.png": 3358,
	"./bottom_sheet_icon_email.svg": 1915,
	"./bottom_sheet_icon_mobile.svg": 1916,
	"./bottom_sheet_icon_pan.svg": 1011,
	"./brinks-logo.png": 3359,
	"./brinks_logo.svg": 1154,
	"./bse-logo.png": 3453,
	"./buildwealth.svg": 1917,
	"./buildwealth_1.svg": 1918,
	"./buildwealth_2.svg": 1919,
	"./buildwealth_3.svg": 1920,
	"./buildwealth_4.svg": 1921,
	"./bus.png": 3360,
	"./buy_gold_icon@2x.png": 3454,
	"./calculator.svg": 1922,
	"./calendar2.png": 3455,
	"./call.svg": 1923,
	"./cams-logo.svg": 1924,
	"./cams_email.png": 3361,
	"./cams_folio.png": 3456,
	"./cams_period.png": 3457,
	"./cams_pwd.png": 3458,
	"./cams_statement.png": 3459,
	"./cancel.svg": 1925,
	"./cancel_icon.svg": 1926,
	"./cancelled.svg": 1927,
	"./cancelled_cheque.svg": 1928,
	"./capital_gains_icon.svg": 1929,
	"./car.png": 3362,
	"./card.png": 3460,
	"./care_health_logo_with_caption.svg": 1930,
	"./cart_icon.svg": 976,
	"./cas_email.png": 3363,
	"./catchup.png": 3364,
	"./caution.svg": 536,
	"./check.svg": 1931,
	"./check_circled.svg": 806,
	"./check_green_pg.svg": 1932,
	"./check_icon.png": 3321,
	"./check_icon.svg": 946,
	"./check_icon_color.svg": 1933,
	"./check_mark copy.png": 3461,
	"./check_mark.png": 3322,
	"./check_selected.svg": 959,
	"./check_selected_blue.svg": 947,
	"./check_small_icon.png": 3462,
	"./checkbox.svg": 1934,
	"./checkbox_gray.png": 3463,
	"./checked.svg": 948,
	"./child_education.svg": 1935,
	"./child_education_icon.png": 3365,
	"./childs_education.svg": 1936,
	"./childs_wedding.svg": 1937,
	"./circle_layout.svg": 1155,
	"./claim_settle_icn.png": 3366,
	"./close_grey.svg": 1012,
	"./close_icn.png": 3464,
	"./close_icn.svg": 1156,
	"./close_icon.svg": 1013,
	"./close_icon_grey.svg": 807,
	"./close_small.svg": 1014,
	"./close_white_icon.svg": 1938,
	"./collapse.svg": 1939,
	"./comfortable_edu.png": 3367,
	"./comfortable_wedding.png": 3368,
	"./completed.svg": 1157,
	"./completed_step.svg": 917,
	"./congratulations_illustration.svg": 1940,
	"./congratulations_illustration_myway.svg": 1941,
	"./conquer_mental_edge.svg": 1942,
	"./contact_details_icn.svg": 1015,
	"./contact_details_icon.svg": 1016,
	"./convertedIcon.svg": 1943,
	"./copy_icn.svg": 1158,
	"./correct_otm_sample_image.svg": 1159,
	"./cost.svg": 1944,
	"./cover_age_icn.png": 3369,
	"./cover_period_icon.png": 3303,
	"./cover_small_icn.png": 3465,
	"./crd_pan.png": 3370,
	"./cred.svg": 1017,
	"./critical_illness_fisdom.svg": 1945,
	"./critical_illness_icon.png": 3466,
	"./critical_illness_myway.svg": 1946,
	"./cross.svg": 1947,
	"./cub.png": 3467,
	"./cub.svg": 1948,
	"./current_step.svg": 1018,
	"./date.png": 3468,
	"./debt.svg": 1949,
	"./decr_arrow.svg": 1950,
	"./delete_new.png": 3304,
	"./deleted.svg": 1951,
	"./deliver_gold_icon@2x.png": 3469,
	"./dengue_icon_fisdom.svg": 1952,
	"./dengue_icon_myway.svg": 1953,
	"./designation_dark_icn.png": 3470,
	"./designation_icn.png": 3471,
	"./direction_icn.png": 3371,
	"./dividend_icon.png": 3472,
	"./diwali_banner.svg": 1160,
	"./diy_debt.svg": 1954,
	"./diy_debt_icon.svg": 1019,
	"./diy_eq_icon.svg": 1955,
	"./diy_equity.svg": 1956,
	"./diy_equity_icon.svg": 1020,
	"./diy_filter.svg": 1957,
	"./diy_goal_icon.svg": 1161,
	"./diy_hybrid.svg": 1958,
	"./diy_hybrid_icon.svg": 1021,
	"./dmi-finance.svg": 1959,
	"./dmi_logo.svg": 1960,
	"./dob_dark_icn.png": 3312,
	"./dob_icn.png": 3473,
	"./done.svg": 1961,
	"./done_icon.png": 3323,
	"./dot_down_arrow.svg": 1022,
	"./down_arrow.svg": 393,
	"./down_arrow_green.png": 3372,
	"./down_arrow_myway.svg": 951,
	"./down_nav.svg": 1962,
	"./download.svg": 541,
	"./download_icon.svg": 1963,
	"./dropdown_arrow.png": 3474,
	"./duration.svg": 1023,
	"./earning_wallet_icon.png": 3475,
	"./easy_secure_icon.svg": 1162,
	"./easy_sip.svg": 1163,
	"./ec_info.svg": 960,
	"./edit.svg": 1964,
	"./edit_green.svg": 1965,
	"./edit_icon.svg": 961,
	"./education.svg": 1966,
	"./education_1.svg": 1967,
	"./education_dark_icn.png": 3324,
	"./education_icn.png": 3476,
	"./elss.svg": 1968,
	"./elss_banner.svg": 1969,
	"./email.svg": 1970,
	"./email2.svg": 1971,
	"./email_dark_icn.png": 3305,
	"./email_icn.png": 3477,
	"./email_verification.svg": 1164,
	"./encryption_ssl_logo.svg": 1024,
	"./error.png": 3478,
	"./error_icon.svg": 1025,
	"./error_illustration_fisdom.svg": 977,
	"./error_popup_icon.svg": 1972,
	"./esign_intro_illustration_fisdom.svg": 1165,
	"./eta_icon.png": 3306,
	"./eta_icon.svg": 978,
	"./etli_logo.svg": 1973,
	"./etli_logo2.svg": 979,
	"./expand.svg": 1974,
	"./expand_icn.png": 3290,
	"./explore.svg": 1975,
	"./export_transaction_icon.svg": 1976,
	"./ext_portfolio.svg": 1026,
	"./eye_icon.svg": 1027,
	"./fa_camera.svg": 1028,
	"./fa_image.svg": 962,
	"./facebook.svg": 1977,
	"./fallback_icon.svg": 497,
	"./faq_add_icon.svg": 1166,
	"./father_dark_icn.png": 3373,
	"./father_icn.png": 3479,
	"./female_icon.svg": 1167,
	"./fhc.png": 708,
	"./fhc.svg": 1978,
	"./fhc_landing.svg": 1168,
	"./file.svg": 1979,
	"./filter.svg": 952,
	"./filter_icon.svg": 1169,
	"./filter_nav_icon.png": 3480,
	"./filter_sign.svg": 1980,
	"./finity/Aggressive_Hybrid.svg": 1981,
	"./finity/Arbitrage.svg": 1982,
	"./finity/Banking_PSU.svg": 1983,
	"./finity/Children.svg": 1984,
	"./finity/Conservative_Hybrid.svg": 1985,
	"./finity/Corporate_Bond.svg": 1986,
	"./finity/Credit_Risk.svg": 1987,
	"./finity/Dividend_Yield.svg": 1988,
	"./finity/Dynamic_Asset_Allocation.svg": 1989,
	"./finity/ELSS_Tax_Savings.svg": 1990,
	"./finity/Equity_Savings.svg": 1991,
	"./finity/Floater.svg": 1992,
	"./finity/FoF.svg": 1993,
	"./finity/Gilt.svg": 1994,
	"./finity/Gold_Funds.svg": 1995,
	"./finity/Gold_banner.jpg": 4170,
	"./finity/Gold_banner1.jpg": 4171,
	"./finity/Group 9947.svg": 1996,
	"./finity/Group 9964.svg": 1997,
	"./finity/Group 9998.svg": 1998,
	"./finity/Index.svg": 1999,
	"./finity/International.svg": 2000,
	"./finity/Large_cap.svg": 2001,
	"./finity/Medium_to_Long.svg": 2002,
	"./finity/Mid_cap.svg": 2003,
	"./finity/Multi_Asset_Allocation.svg": 2004,
	"./finity/Multi_Cap.svg": 2005,
	"./finity/Overnight.svg": 2006,
	"./finity/Retirement.svg": 2007,
	"./finity/Sectoral_Thematic.svg": 2008,
	"./finity/Short.svg": 2009,
	"./finity/Small_cap.svg": 2010,
	"./finity/Ultra_Short.svg": 2011,
	"./finity/Value_Oriented.svg": 2012,
	"./finity/acconts_linked.svg": 2013,
	"./finity/account.svg": 2014,
	"./finity/account1.svg": 2015,
	"./finity/account_icon.svg": 2016,
	"./finity/account_linked.svg": 1170,
	"./finity/active_passive_background.svg": 1171,
	"./finity/add.svg": 1172,
	"./finity/add_bank.svg": 1173,
	"./finity/address.svg": 2017,
	"./finity/address_.svg": 2018,
	"./finity/address_icon.svg": 963,
	"./finity/address_proof_front.svg": 1174,
	"./finity/address_proof_rear.svg": 1175,
	"./finity/advisory_entry_hero.svg": 1176,
	"./finity/advisory_female.svg": 2019,
	"./finity/advisory_male.svg": 2020,
	"./finity/amount_icon.svg": 1029,
	"./finity/aoc_trading.svg": 2021,
	"./finity/approved.svg": 2022,
	"./finity/attached.svg": 2023,
	"./finity/b1.svg": 2024,
	"./finity/b2.svg": 2025,
	"./finity/b3.svg": 2026,
	"./finity/b4.svg": 2027,
	"./finity/back_nav_bar_icon_1.svg": 2028,
	"./finity/back_nav_bar_icon_2.svg": 2029,
	"./finity/back_nav_bar_icon_finity.svg": 2030,
	"./finity/bacteria_myway.svg": 2031,
	"./finity/badge-info.svg": 2032,
	"./finity/bank.svg": 2033,
	"./finity/bank_add_failed.svg": 2034,
	"./finity/bank_building.svg": 1177,
	"./finity/bank_failed.svg": 2035,
	"./finity/bank_verification_success.svg": 2036,
	"./finity/bank_verify_pending.svg": 2037,
	"./finity/banner_ext_pf.svg": 2038,
	"./finity/bed_corona_myway.svg": 2039,
	"./finity/bfdl_selected.png": 3481,
	"./finity/bg_crousal.svg": 2040,
	"./finity/bottomsheet_account_exist.svg": 2041,
	"./finity/bottomsheet_verify_email.svg": 2042,
	"./finity/bottomsheet_verify_mobile.svg": 2043,
	"./finity/bse_icon.svg": 2044,
	"./finity/buyback.svg": 1178,
	"./finity/buyback_transparent.svg": 2045,
	"./finity/calculatemi.svg": 2046,
	"./finity/calender-rs.svg": 1179,
	"./finity/call_back_confirm.png": 3374,
	"./finity/call_back_confirm.svg": 2047,
	"./finity/cancelled_sip_icon.svg": 2048,
	"./finity/card_upload_selfie.svg": 2049,
	"./finity/carousel-next.svg": 1180,
	"./finity/carousel-prev.svg": 1181,
	"./finity/cas_not_received.svg": 2050,
	"./finity/cash-payment.svg": 1182,
	"./finity/certificate-rs.svg": 2051,
	"./finity/chat_bubble.svg": 1183,
	"./finity/circle_loader.gif": 2052,
	"./finity/complete_kyc.svg": 2053,
	"./finity/completed.svg": 1184,
	"./finity/completed_step.svg": 1185,
	"./finity/congrats.svg": 2054,
	"./finity/congratulations.svg": 2055,
	"./finity/congratulations_illustration.svg": 1030,
	"./finity/corpus_switch.svg": 1186,
	"./finity/crd_gold_info.svg": 1187,
	"./finity/cross.svg": 2056,
	"./finity/dark_selfie.svg": 1188,
	"./finity/debt_icon.svg": 1031,
	"./finity/default.svg": 2057,
	"./finity/deliver.svg": 2058,
	"./finity/digilocker_failed.svg": 1189,
	"./finity/digilocker_kyc.svg": 1190,
	"./finity/diwali_banner_finity.svg": 1191,
	"./finity/diy_kyc.svg": 1032,
	"./finity/diy_search_iframe.svg": 1192,
	"./finity/doc-uploaded.svg": 2059,
	"./finity/document.svg": 2060,
	"./finity/document_.svg": 2061,
	"./finity/down_arrow.svg": 2062,
	"./finity/download.svg": 2063,
	"./finity/eligibility.svg": 2064,
	"./finity/entry_insurance_advisory.svg": 1193,
	"./finity/eq_icon.svg": 1033,
	"./finity/eq_pg_success.svg": 2065,
	"./finity/equity_derivatives_transparent.svg": 2066,
	"./finity/error_illustration.svg": 808,
	"./finity/error_illustration_myway.svg": 980,
	"./finity/esign-kyc.svg": 1194,
	"./finity/esign_intro_illustration_myway.svg": 1195,
	"./finity/esign_kyc_fail.svg": 1196,
	"./finity/expand_less.svg": 1197,
	"./finity/expand_more.svg": 1198,
	"./finity/expense.svg": 1199,
	"./finity/experience.svg": 2067,
	"./finity/external_portfolio.svg": 2068,
	"./finity/failed_order_delivery.svg": 2069,
	"./finity/finity_logo.svg": 2070,
	"./finity/finity_logo_icon.svg": 2071,
	"./finity/finity_logo_icon_white.svg": 2072,
	"./finity/finity_logo_white.svg": 809,
	"./finity/foreign-location.svg": 1200,
	"./finity/fpo.svg": 1201,
	"./finity/fpo_transparent.svg": 2073,
	"./finity/free_gold_etf.svg": 2074,
	"./finity/freedom.svg": 1202,
	"./finity/fund_details_cover.png": 3482,
	"./finity/fund_house_icon.svg": 2075,
	"./finity/fundwise.svg": 2076,
	"./finity/fyntune_landing_page_hero.svg": 1203,
	"./finity/global_indices.svg": 1204,
	"./finity/go_to_gallery_green.svg": 1205,
	"./finity/goal_icon.svg": 1206,
	"./finity/goalwise.svg": 2077,
	"./finity/gold.svg": 2078,
	"./finity/gold_pattern.png": 3375,
	"./finity/group.svg": 1207,
	"./finity/growth.svg": 2079,
	"./finity/hand.svg": 599,
	"./finity/home_insurance_icon.svg": 2080,
	"./finity/hourglass.svg": 1208,
	"./finity/hybrid_icon.svg": 1034,
	"./finity/ic_aadhaar_card.svg": 2081,
	"./finity/ic_aadhaar_handy.svg": 1209,
	"./finity/ic_address_details.svg": 2082,
	"./finity/ic_auth_bank.svg": 2083,
	"./finity/ic_auth_bank_myway.svg": 1035,
	"./finity/ic_bank_added.svg": 2084,
	"./finity/ic_bank_not_added.svg": 2085,
	"./finity/ic_bank_not_rejected.svg": 1210,
	"./finity/ic_bank_partial_add.svg": 1211,
	"./finity/ic_bank_partial_added.svg": 1036,
	"./finity/ic_bank_verified.svg": 1212,
	"./finity/ic_benefit_gold.svg": 1213,
	"./finity/ic_btm_mail_check.svg": 2086,
	"./finity/ic_btm_sheet_high_returns.svg": 1214,
	"./finity/ic_buy_gold.svg": 2087,
	"./finity/ic_card_kyc_default.svg": 2088,
	"./finity/ic_card_kyc_pending.svg": 2089,
	"./finity/ic_card_kyc_underprocess.svg": 2090,
	"./finity/ic_customer_portal.svg": 2091,
	"./finity/ic_date_confirmed.svg": 1215,
	"./finity/ic_date_payment.svg": 1216,
	"./finity/ic_db_account.svg": 2092,
	"./finity/ic_db_help.svg": 2093,
	"./finity/ic_db_invest.svg": 2094,
	"./finity/ic_db_invest_solid.svg": 2095,
	"./finity/ic_db_kyc.svg": 2096,
	"./finity/ic_db_portfolio.svg": 2097,
	"./finity/ic_db_refer.svg": 2098,
	"./finity/ic_delivery.svg": 2099,
	"./finity/ic_diverse_pf.svg": 2100,
	"./finity/ic_document_amount.svg": 2101,
	"./finity/ic_document_card.svg": 2102,
	"./finity/ic_document_cash.svg": 2103,
	"./finity/ic_document_cloud.svg": 2104,
	"./finity/ic_document_copy.svg": 1037,
	"./finity/ic_document_location.svg": 1217,
	"./finity/ic_document_mobile.svg": 2105,
	"./finity/ic_document_note.svg": 2106,
	"./finity/ic_email.svg": 1218,
	"./finity/ic_esign_done.svg": 2107,
	"./finity/ic_esign_done_finity.svg": 1038,
	"./finity/ic_esign_kyc.svg": 2108,
	"./finity/ic_esign_otp.svg": 2109,
	"./finity/ic_esign_otp_finity.svg": 964,
	"./finity/ic_fin_tools_fhc.svg": 2110,
	"./finity/ic_fin_tools_risk.svg": 2111,
	"./finity/ic_get_money.svg": 2112,
	"./finity/ic_gold_added.svg": 2113,
	"./finity/ic_gold_provider.svg": 2114,
	"./finity/ic_help.svg": 2115,
	"./finity/ic_higher_returns.svg": 2116,
	"./finity/ic_how_to_claim.svg": 1219,
	"./finity/ic_how_to_claim2.svg": 1220,
	"./finity/ic_hs_cover_amount.svg": 1221,
	"./finity/ic_hs_cover_periods.svg": 1222,
	"./finity/ic_hs_insured.svg": 1223,
	"./finity/ic_hs_medical_checkup.svg": 2117,
	"./finity/ic_hs_pay_freq.svg": 1224,
	"./finity/ic_hs_policy.svg": 1225,
	"./finity/ic_indian_resident.svg": 2118,
	"./finity/ic_input.svg": 2119,
	"./finity/ic_input_65.svg": 2120,
	"./finity/ic_input_myway.svg": 1226,
	"./finity/ic_insta_fund_redemption.svg": 2121,
	"./finity/ic_instant.svg": 1227,
	"./finity/ic_instant_withdrawal.svg": 1228,
	"./finity/ic_intelligent_pf.svg": 2122,
	"./finity/ic_invest_build_wealth.svg": 2123,
	"./finity/ic_invest_explore_mf.svg": 2124,
	"./finity/ic_invest_gold.svg": 2125,
	"./finity/ic_invest_hundered_mf.svg": 2126,
	"./finity/ic_invest_insurance.svg": 2127,
	"./finity/ic_invest_learn.svg": 2128,
	"./finity/ic_invest_nfo.svg": 2129,
	"./finity/ic_invest_nps.svg": 2130,
	"./finity/ic_invest_save_tax.svg": 2131,
	"./finity/ic_ipo.svg": 2132,
	"./finity/ic_kyc_complete.svg": 2133,
	"./finity/ic_kyc_incomplete.svg": 2134,
	"./finity/ic_kyc_rejected.svg": 2135,
	"./finity/ic_kyc_under_process.svg": 2136,
	"./finity/ic_line.svg": 2137,
	"./finity/ic_loan_schedule.svg": 2138,
	"./finity/ic_locker.svg": 1229,
	"./finity/ic_low_risk.svg": 2139,
	"./finity/ic_mail.svg": 2140,
	"./finity/ic_make_payment.svg": 2141,
	"./finity/ic_medical_checkup.svg": 1230,
	"./finity/ic_medical_checkup2.svg": 1231,
	"./finity/ic_mobile.svg": 1232,
	"./finity/ic_no_doc.svg": 1233,
	"./finity/ic_onetime.svg": 2142,
	"./finity/ic_pan_card.svg": 2143,
	"./finity/ic_personal_accident.svg": 2144,
	"./finity/ic_pf_gold.svg": 2145,
	"./finity/ic_pf_insurance.svg": 2146,
	"./finity/ic_pf_withdraw.svg": 2147,
	"./finity/ic_policy_period.svg": 1234,
	"./finity/ic_popup_kyc.svg": 2148,
	"./finity/ic_popup_kyc_pending.svg": 1039,
	"./finity/ic_popup_kyc_underprocess.svg": 2149,
	"./finity/ic_popup_kyc_verified.svg": 2150,
	"./finity/ic_popup_premium_onboarding_big.svg": 2151,
	"./finity/ic_premium_onboarding.svg": 2152,
	"./finity/ic_premium_onboarding_mid.svg": 2153,
	"./finity/ic_premium_onboarding_small.svg": 2154,
	"./finity/ic_process_done.svg": 1040,
	"./finity/ic_purity.svg": 1235,
	"./finity/ic_read.svg": 1236,
	"./finity/ic_risk_analyse.svg": 2155,
	"./finity/ic_save.svg": 1237,
	"./finity/ic_save_for_goal.svg": 2156,
	"./finity/ic_secure_vault.svg": 1238,
	"./finity/ic_sell_gold.svg": 2157,
	"./finity/ic_short_term_inv.svg": 2158,
	"./finity/ic_sip.svg": 2159,
	"./finity/ic_stocks.svg": 2160,
	"./finity/ic_term_insurance.svg": 2161,
	"./finity/ic_to_sell_gold.svg": 1239,
	"./finity/ic_upgrade.svg": 1240,
	"./finity/ic_verify_otp.svg": 2162,
	"./finity/ic_verify_otp_finity.svg": 1041,
	"./finity/ic_wallet.svg": 2163,
	"./finity/ic_whats_covered.svg": 1241,
	"./finity/ic_whats_not_covered.svg": 1242,
	"./finity/ic_whatsapp_failed.svg": 1243,
	"./finity/ic_whatsapp_small.svg": 2164,
	"./finity/ic_why_fyn1.png": 3376,
	"./finity/ic_why_fyn2.png": 3377,
	"./finity/ic_why_fyn3.png": 3378,
	"./finity/ic_why_hs.svg": 2165,
	"./finity/ic_why_hs2.svg": 2166,
	"./finity/ic_why_hs3.svg": 2167,
	"./finity/ic_why_hs4.svg": 2168,
	"./finity/ic_why_hs_gmc_1.svg": 2169,
	"./finity/ic_why_hs_gmc_2.svg": 2170,
	"./finity/ic_why_hs_gmc_3.svg": 2171,
	"./finity/ic_why_hs_loan.svg": 2172,
	"./finity/ic_why_loan.svg": 2173,
	"./finity/ic_why_loan1.svg": 2174,
	"./finity/ic_why_loan2.svg": 2175,
	"./finity/ic_why_loan3.svg": 2176,
	"./finity/ic_why_loan_3.svg": 2177,
	"./finity/ic_why_loan_4.svg": 2178,
	"./finity/ic_withdrawal.svg": 2179,
	"./finity/icn_Issue_loan.svg": 2180,
	"./finity/icn_ROI.svg": 2181,
	"./finity/icn_aadhaar_kyc.svg": 2182,
	"./finity/icn_aadhaar_kyc_small.svg": 1244,
	"./finity/icn_application_created.svg": 1245,
	"./finity/icn_assistance.svg": 1246,
	"./finity/icn_awaiting_period_myway.svg": 2183,
	"./finity/icn_b1_m.svg": 2184,
	"./finity/icn_b2_m.svg": 2185,
	"./finity/icn_b3_m.svg": 2186,
	"./finity/icn_b3_myway.svg": 2187,
	"./finity/icn_b4_m.svg": 2188,
	"./finity/icn_b_1.svg": 2189,
	"./finity/icn_b_2.svg": 2190,
	"./finity/icn_b_3.svg": 2191,
	"./finity/icn_bt_1.svg": 2192,
	"./finity/icn_bt_2.svg": 2193,
	"./finity/icn_bt_3.svg": 2194,
	"./finity/icn_ca.svg": 1247,
	"./finity/icn_contact.svg": 2195,
	"./finity/icn_couple.svg": 2196,
	"./finity/icn_crousal_card1.svg": 1248,
	"./finity/icn_crousal_card_1.svg": 2197,
	"./finity/icn_diseases_insurance.svg": 2198,
	"./finity/icn_end_date.svg": 1249,
	"./finity/icn_expert_match.svg": 2199,
	"./finity/icn_file_itr.svg": 2200,
	"./finity/icn_free.svg": 1250,
	"./finity/icn_fundwise_summary.svg": 2201,
	"./finity/icn_gold.svg": 2202,
	"./finity/icn_hero.svg": 2203,
	"./finity/icn_hs_assistance.svg": 2204,
	"./finity/icn_hs_no_document.svg": 2205,
	"./finity/icn_hs_payment.svg": 2206,
	"./finity/icn_identity.svg": 1251,
	"./finity/icn_issue_date.svg": 1252,
	"./finity/icn_journey_start.svg": 2207,
	"./finity/icn_kids.svg": 2208,
	"./finity/icn_kyc_completed.svg": 2209,
	"./finity/icn_kyc_doc_rejected.svg": 2210,
	"./finity/icn_kyc_doc_verification.svg": 2211,
	"./finity/icn_kyc_incomplete.svg": 2212,
	"./finity/icn_landing_card_1.svg": 2213,
	"./finity/icn_landing_card_2.svg": 2214,
	"./finity/icn_landing_card_3.svg": 2215,
	"./finity/icn_loan_amnt.svg": 2216,
	"./finity/icn_lourney_end.svg": 2217,
	"./finity/icn_mail_id.svg": 1253,
	"./finity/icn_msg_sent.svg": 2218,
	"./finity/icn_notification.svg": 2219,
	"./finity/icn_nps.svg": 2220,
	"./finity/icn_ongoingcovid_myway.svg": 2221,
	"./finity/icn_online_support.svg": 2222,
	"./finity/icn_parents.svg": 2223,
	"./finity/icn_payment_frequency.svg": 1254,
	"./finity/icn_phn_no.svg": 1255,
	"./finity/icn_plan_type.svg": 1256,
	"./finity/icn_policy_found_f.svg": 1257,
	"./finity/icn_review_1.svg": 1258,
	"./finity/icn_review_2.svg": 1259,
	"./finity/icn_review_3.svg": 1260,
	"./finity/icn_review_edit.svg": 2224,
	"./finity/icn_review_file.svg": 2225,
	"./finity/icn_salaried.svg": 2226,
	"./finity/icn_satisfied_clients.svg": 2227,
	"./finity/icn_scroller_card1.svg": 1261,
	"./finity/icn_self_employed.svg": 2228,
	"./finity/icn_self_itr.svg": 1262,
	"./finity/icn_service_ratings.svg": 2229,
	"./finity/icn_start_date_1.svg": 1263,
	"./finity/icn_tax_filing.svg": 2230,
	"./finity/icn_tax_made_simple.svg": 2231,
	"./finity/icn_tax_statement.svg": 2232,
	"./finity/icn_time.svg": 1264,
	"./finity/icn_top_equity_funds.svg": 2233,
	"./finity/icn_upload_form_16.svg": 2234,
	"./finity/icn_zero_paper.svg": 1265,
	"./finity/icon_bull.svg": 1266,
	"./finity/icon_color.svg": 2235,
	"./finity/icon_play_btn.svg": 1267,
	"./finity/icons-07.svg": 810,
	"./finity/icons-08.svg": 811,
	"./finity/icons-09.svg": 812,
	"./finity/identity.svg": 2236,
	"./finity/identity_.svg": 2237,
	"./finity/idfc_card.svg": 2238,
	"./finity/ill_refer_earn.svg": 1268,
	"./finity/illustration.svg": 2239,
	"./finity/ils_alternate_assets.svg": 1269,
	"./finity/ils_covid_failed.svg": 2240,
	"./finity/ils_covid_failed_copy_2.svg": 2241,
	"./finity/ils_covid_pending.svg": 2242,
	"./finity/ils_covid_success.svg": 2243,
	"./finity/ils_digilocker_failed.svg": 1270,
	"./finity/ils_digilocker_success.svg": 2244,
	"./finity/ils_error.svg": 1271,
	"./finity/ils_esign_failed.svg": 1272,
	"./finity/ils_esign_failed_myway.svg": 1273,
	"./finity/ils_esign_kyc.svg": 1274,
	"./finity/ils_esign_success.svg": 2245,
	"./finity/ils_esign_success_myway.svg": 1275,
	"./finity/ils_gold_purchase_failed.svg": 2246,
	"./finity/ils_gold_purchase_pending.svg": 2247,
	"./finity/ils_gold_purchase_success.svg": 2248,
	"./finity/ils_gold_sell_failed.svg": 2249,
	"./finity/ils_gold_sell_success.svg": 2250,
	"./finity/ils_hassle_free.svg": 1276,
	"./finity/ils_loan_approve.svg": 2251,
	"./finity/ils_loan_email.svg": 2252,
	"./finity/ils_loan_failed.svg": 2253,
	"./finity/ils_loan_intro_card.svg": 2254,
	"./finity/ils_loan_status.svg": 2255,
	"./finity/ils_login.svg": 813,
	"./finity/ils_register.svg": 2256,
	"./finity/ils_timeout.svg": 1277,
	"./finity/inactive-policy-background.svg": 1278,
	"./finity/inc_infected_myway.svg": 2257,
	"./finity/inc_outside_india_myway.svg": 2258,
	"./finity/inc_quarantine_myway.svg": 2259,
	"./finity/inc_travel_covid.svg": 2260,
	"./finity/income_.svg": 2261,
	"./finity/info_icon.svg": 949,
	"./finity/info_icon_myway.svg": 981,
	"./finity/insta_switch.svg": 814,
	"./finity/invest.svg": 1279,
	"./finity/invest_fund.svg": 1280,
	"./finity/invest_process.svg": 1281,
	"./finity/investment.svg": 2262,
	"./finity/ipo.svg": 1282,
	"./finity/ipo_transparent.svg": 2263,
	"./finity/iv_aadhar.svg": 1283,
	"./finity/iv_analyst_view.svg": 2264,
	"./finity/iv_close_demat.svg": 1284,
	"./finity/iv_closure_approved.svg": 2265,
	"./finity/iv_closure_pending.svg": 2266,
	"./finity/iv_closure_rejected.svg": 2267,
	"./finity/iv_closure_status.svg": 1285,
	"./finity/iv_earn_reward.svg": 1286,
	"./finity/iv_esign.svg": 1287,
	"./finity/iv_esign_top.svg": 1288,
	"./finity/iv_freedomplanIntro.svg": 2268,
	"./finity/iv_lock_in.svg": 2269,
	"./finity/iv_no_rewards.svg": 1289,
	"./finity/iv_otp.svg": 1290,
	"./finity/iv_profile.svg": 1291,
	"./finity/iv_profile_support.svg": 1292,
	"./finity/iv_refer_and_earn.svg": 2270,
	"./finity/iv_returns.svg": 2271,
	"./finity/iv_save_taxes.svg": 2272,
	"./finity/iv_thumbs_up_active.svg": 2273,
	"./finity/iv_upload_attachment.svg": 1293,
	"./finity/ivn_account_exists.svg": 1294,
	"./finity/ivn_gift_colored.svg": 2274,
	"./finity/kyc_complete_setup.svg": 2275,
	"./finity/kyc_default.svg": 2276,
	"./finity/kyc_error.svg": 2277,
	"./finity/kyc_esign.svg": 2278,
	"./finity/kyc_illust.svg": 1042,
	"./finity/kyc_inprogress.svg": 2279,
	"./finity/kyc_loader.gif": 3582,
	"./finity/kyc_rejected.svg": 2280,
	"./finity/kyc_status_icon.svg": 1295,
	"./finity/kyc_upgrade.svg": 2281,
	"./finity/landing_call_back_button.svg": 1296,
	"./finity/link_account.svg": 1297,
	"./finity/link_icon.svg": 1298,
	"./finity/loader_gif.gif": 1043,
	"./finity/loan.svg": 1299,
	"./finity/loan_hand.svg": 2282,
	"./finity/loan_icon.svg": 2283,
	"./finity/loan_success.svg": 2284,
	"./finity/lock_key.svg": 2285,
	"./finity/lottie/account_manage": 1300,
	"./finity/lottie/account_manage.json": 1300,
	"./finity/lottie/calendar": 1044,
	"./finity/lottie/calendar.json": 1044,
	"./finity/lottie/calender_complete": 1301,
	"./finity/lottie/calender_complete.json": 1301,
	"./finity/lottie/calender_error": 1302,
	"./finity/lottie/calender_error.json": 1302,
	"./finity/lottie/calender_pause": 1303,
	"./finity/lottie/calender_pause.json": 1303,
	"./finity/lottie/calender_reinvest": 1304,
	"./finity/lottie/calender_reinvest.json": 1304,
	"./finity/lottie/coin1": 1305,
	"./finity/lottie/coin1.json": 1305,
	"./finity/lottie/coin2": 1306,
	"./finity/lottie/coin2.json": 1306,
	"./finity/lottie/coin3": 1307,
	"./finity/lottie/coin3.json": 1307,
	"./finity/lottie/debt": 1308,
	"./finity/lottie/debt.json": 1308,
	"./finity/lottie/equity": 1309,
	"./finity/lottie/equity.json": 1309,
	"./finity/lottie/hybrid": 1310,
	"./finity/lottie/hybrid.json": 1310,
	"./finity/lottie/insights": 1311,
	"./finity/lottie/insights.json": 1311,
	"./finity/lottie/kyc_complete": 1045,
	"./finity/lottie/kyc_complete.json": 1045,
	"./finity/lottie/no_mf_order": 1046,
	"./finity/lottie/no_mf_order.json": 1046,
	"./finity/lottie/one_kyc": 1312,
	"./finity/lottie/one_kyc.json": 1312,
	"./finity/lottie/order_place": 1313,
	"./finity/lottie/order_place.json": 1313,
	"./finity/lottie/signfier": 1047,
	"./finity/lottie/signfier.json": 1047,
	"./finity/lottie/success_animation": 1048,
	"./finity/lottie/success_animation.json": 1048,
	"./finity/lottie/tick": 1049,
	"./finity/lottie/tick.json": 1049,
	"./finity/lottie/wallet": 1050,
	"./finity/lottie/wallet.json": 1050,
	"./finity/lottie/withdrawal": 1314,
	"./finity/lottie/withdrawal.json": 1314,
	"./finity/lottie/zero_investment": 1315,
	"./finity/lottie/zero_investment.json": 1315,
	"./finity/mandate_pending_icon.svg": 1051,
	"./finity/mc_nfo.svg": 2286,
	"./finity/meter-aggressive.svg": 1316,
	"./finity/meter-conservative.svg": 1317,
	"./finity/meter-moderate.svg": 1318,
	"./finity/meter-moderately-aggressive.svg": 1319,
	"./finity/meter-moderately-conservative.svg": 1320,
	"./finity/mobile_credit_card.svg": 2287,
	"./finity/mobilemc_nfo.svg": 2288,
	"./finity/money_pig.svg": 2289,
	"./finity/more.svg": 2290,
	"./finity/mutual_fund.svg": 2291,
	"./finity/nav_right.svg": 1321,
	"./finity/ncd.svg": 1322,
	"./finity/ncd_transparent.svg": 2292,
	"./finity/next_arrow.svg": 2293,
	"./finity/next_nav_bar_icon_finity.svg": 2294,
	"./finity/nifty_backers.svg": 1323,
	"./finity/no_stocks_nri.svg": 1324,
	"./finity/nominee.svg": 1325,
	"./finity/not_eligible.svg": 2295,
	"./finity/nps.svg": 2296,
	"./finity/nps_report_icon.svg": 2297,
	"./finity/one_account.svg": 2298,
	"./finity/one_time_icn.svg": 2299,
	"./finity/order_id.svg": 1326,
	"./finity/order_placed_illustration.svg": 2300,
	"./finity/pan.svg": 2301,
	"./finity/pan_approved.svg": 2302,
	"./finity/pan_card.svg": 1327,
	"./finity/pan_default.svg": 2303,
	"./finity/pan_flash_on.svg": 2304,
	"./finity/pan_incorrect_placed.svg": 2305,
	"./finity/pan_sample_right.svg": 1328,
	"./finity/pan_verification_failed.svg": 2306,
	"./finity/paperless.svg": 2307,
	"./finity/passiveFundKeyInsights.svg": 1329,
	"./finity/passive_index.svg": 2308,
	"./finity/passive_index_funds.svg": 2309,
	"./finity/passive_index_keyinsight_1.svg": 2310,
	"./finity/passive_info1.svg": 1330,
	"./finity/passive_info2.svg": 1331,
	"./finity/passive_info3.svg": 1332,
	"./finity/pause_cancel_sip.svg": 1333,
	"./finity/paused_sip_icon.svg": 2311,
	"./finity/payment_failed.svg": 2312,
	"./finity/payment_success.svg": 2313,
	"./finity/payment_transaction.svg": 2314,
	"./finity/pending.svg": 2315,
	"./finity/pending_order_delivery.svg": 2316,
	"./finity/pending_purchase.svg": 2317,
	"./finity/pending_redemption.svg": 2318,
	"./finity/people_sitting_myway.svg": 2319,
	"./finity/performance.svg": 2320,
	"./finity/personal.svg": 1334,
	"./finity/pg_success.svg": 2321,
	"./finity/pin_changed.svg": 815,
	"./finity/policy_icon.svg": 1335,
	"./finity/popup_kyc_pending.svg": 2322,
	"./finity/portfolio-rebal.svg": 816,
	"./finity/portfolio_something_wrong.svg": 1336,
	"./finity/profile.svg": 1337,
	"./finity/rebalance_date.svg": 1338,
	"./finity/rebalance_pointer.svg": 1339,
	"./finity/rebalance_report.svg": 1340,
	"./finity/rec_point1.svg": 1341,
	"./finity/rec_point2.svg": 1342,
	"./finity/rec_point3.svg": 1343,
	"./finity/rec_point4.svg": 1344,
	"./finity/rec_point5.svg": 1345,
	"./finity/rec_point6.svg": 1346,
	"./finity/refer_gift_icon.svg": 1347,
	"./finity/regi_approved.svg": 2323,
	"./finity/regi_default.svg": 2324,
	"./finity/register_icn.svg": 2325,
	"./finity/replace_bfdl.svg": 1348,
	"./finity/reports_kyc_status.svg": 2326,
	"./finity/residence.svg": 2327,
	"./finity/returns.svg": 2328,
	"./finity/right_arrow.svg": 2329,
	"./finity/right_arrow_small.svg": 1349,
	"./finity/right_icon.svg": 2330,
	"./finity/right_selfie.svg": 1350,
	"./finity/risk_meter.svg": 2331,
	"./finity/risk_profile.svg": 1351,
	"./finity/rp_entry_banner.svg": 1352,
	"./finity/rp_intro_banner.svg": 1052,
	"./finity/safe_secure_journey.svg": 2332,
	"./finity/salary.svg": 2333,
	"./finity/search.svg": 2334,
	"./finity/secure.svg": 1353,
	"./finity/secure_icon.svg": 2335,
	"./finity/selected.svg": 2336,
	"./finity/selfie_approved.svg": 2337,
	"./finity/selfie_default.svg": 2338,
	"./finity/selfie_placeholder.svg": 1354,
	"./finity/sensex_backers.svg": 1355,
	"./finity/server_error_page.svg": 1356,
	"./finity/sgb.svg": 1357,
	"./finity/sgb_transparent.svg": 2339,
	"./finity/share_refer.svg": 2340,
	"./finity/shield.svg": 1358,
	"./finity/sign_approved.svg": 2341,
	"./finity/sign_default.svg": 2342,
	"./finity/singlebed_myway.svg": 2343,
	"./finity/sip.svg": 2344,
	"./finity/sip_action_illustration.svg": 1359,
	"./finity/sip_action_illustration_myway.svg": 982,
	"./finity/sip_corpus_switch.svg": 1360,
	"./finity/sip_date.svg": 1361,
	"./finity/sip_date_icon.svg": 1053,
	"./finity/sip_icn.svg": 2345,
	"./finity/sip_resumed_illustration.svg": 2346,
	"./finity/sip_resumed_illustration_myway.svg": 1054,
	"./finity/sip_switch.svg": 1362,
	"./finity/smart_reco.svg": 817,
	"./finity/start_recording.svg": 1363,
	"./finity/state_ipv_number.svg": 1364,
	"./finity/statements_briefcase.svg": 1055,
	"./finity/status_sip_icon.svg": 1365,
	"./finity/step_complete_check_icn.svg": 1366,
	"./finity/stocks_cip.svg": 2347,
	"./finity/successful_switch.svg": 1367,
	"./finity/sucess_order_delivery.svg": 2348,
	"./finity/surprised.svg": 1368,
	"./finity/switch_icon.svg": 1369,
	"./finity/take_pic_finity.svg": 1370,
	"./finity/team_tag.svg": 2349,
	"./finity/technology_funds.svg": 2350,
	"./finity/term_insurance.svg": 2351,
	"./finity/thematic_funds.svg": 1371,
	"./finity/track_ext_pf.svg": 2352,
	"./finity/track_order.svg": 1372,
	"./finity/track_record.svg": 2353,
	"./finity/transactions.svg": 2354,
	"./finity/trend.svg": 2355,
	"./finity/trust_icon_registration.svg": 2356,
	"./finity/trust_icons.svg": 1056,
	"./finity/update_insurance_myway.svg": 983,
	"./finity/update_mobile.svg": 1373,
	"./finity/upload_doc_banner.svg": 1374,
	"./finity/upload_documents.svg": 1375,
	"./finity/upload_documents_pending.svg": 1376,
	"./finity/upload_error.svg": 2357,
	"./finity/upload_success.svg": 2358,
	"./finity/video_approved.svg": 2359,
	"./finity/video_default.svg": 2360,
	"./finity/video_uploaded_placeholder.svg": 1377,
	"./finity/wallet_icon.svg": 1057,
	"./finity/whatsapp.svg": 1378,
	"./finity/wrong_selfie.svg": 1379,
	"./finity_navlogo.png": 3483,
	"./finshell.svg": 2361,
	"./fisdom/Aggressive_Hybrid.svg": 2362,
	"./fisdom/Arbitrage.svg": 2363,
	"./fisdom/Banking_PSU.svg": 2364,
	"./fisdom/Children.svg": 2365,
	"./fisdom/Conservative_Hybrid.svg": 2366,
	"./fisdom/Corporate_Bond.svg": 2367,
	"./fisdom/Credit_Risk.svg": 2368,
	"./fisdom/Dividend_Yield.svg": 2369,
	"./fisdom/Dynamic_Asset_Allocation.svg": 2370,
	"./fisdom/ELSS_Tax_Savings.svg": 2371,
	"./fisdom/Equity_Savings.svg": 2372,
	"./fisdom/Floater.svg": 2373,
	"./fisdom/FoF.svg": 2374,
	"./fisdom/Gilt.svg": 2375,
	"./fisdom/Gold_Funds.svg": 2376,
	"./fisdom/Gold_banner.jpg": 4172,
	"./fisdom/Gold_banner1.jpg": 4173,
	"./fisdom/Group 9964.svg": 2377,
	"./fisdom/Group 9998.svg": 2378,
	"./fisdom/Index.svg": 2379,
	"./fisdom/International.svg": 2380,
	"./fisdom/Large_cap.svg": 2381,
	"./fisdom/Medium_to_Long.svg": 2382,
	"./fisdom/Mid_cap.svg": 2383,
	"./fisdom/Multi_Asset_Allocation.svg": 2384,
	"./fisdom/Multi_Cap.svg": 2385,
	"./fisdom/Overnight.svg": 2386,
	"./fisdom/Retirement.svg": 2387,
	"./fisdom/Sectoral_Thematic.svg": 2388,
	"./fisdom/Short.svg": 2389,
	"./fisdom/Small_cap.svg": 2390,
	"./fisdom/Ultra_Short.svg": 2391,
	"./fisdom/Value_Oriented.svg": 2392,
	"./fisdom/acconts_linked.svg": 2393,
	"./fisdom/account.svg": 2394,
	"./fisdom/account1.svg": 2395,
	"./fisdom/account_icon.png": 3484,
	"./fisdom/account_linked.svg": 1380,
	"./fisdom/add.svg": 1381,
	"./fisdom/add_bank.svg": 1382,
	"./fisdom/address.svg": 2396,
	"./fisdom/address_.svg": 2397,
	"./fisdom/address_proof_front.svg": 1383,
	"./fisdom/address_proof_rear.svg": 1384,
	"./fisdom/advisory_entry_hero.svg": 1385,
	"./fisdom/advisory_female.svg": 2398,
	"./fisdom/advisory_male.svg": 2399,
	"./fisdom/amount_icon.svg": 1058,
	"./fisdom/aoc_trading.svg": 2400,
	"./fisdom/approved.svg": 2401,
	"./fisdom/arrow-left.svg": 2402,
	"./fisdom/arrow-right.svg": 2403,
	"./fisdom/attached.svg": 2404,
	"./fisdom/b1.svg": 2405,
	"./fisdom/b2.svg": 2406,
	"./fisdom/b3.svg": 2407,
	"./fisdom/b4.svg": 2408,
	"./fisdom/bacteria_fisdom.svg": 2409,
	"./fisdom/badge-info.svg": 2410,
	"./fisdom/bank.svg": 2411,
	"./fisdom/bank_add_failed.svg": 2412,
	"./fisdom/bank_failed.svg": 2413,
	"./fisdom/bank_verification_success.svg": 2414,
	"./fisdom/bank_verify_pending.svg": 2415,
	"./fisdom/banner_ext_pf.svg": 2416,
	"./fisdom/bed_corona_fisdom.svg": 2417,
	"./fisdom/bfdl_selected.png": 3485,
	"./fisdom/bg_crousal.svg": 2418,
	"./fisdom/bg_image_hni.png": 3486,
	"./fisdom/bottomsheet_account_exist.svg": 2419,
	"./fisdom/bottomsheet_verify_email.svg": 2420,
	"./fisdom/bottomsheet_verify_mobile.svg": 2421,
	"./fisdom/bse-logo-mob.jpg": 4174,
	"./fisdom/bse-logo.jpg": 4175,
	"./fisdom/bse_icon.png": 3487,
	"./fisdom/buyback.svg": 1386,
	"./fisdom/buyback_transparent.svg": 2422,
	"./fisdom/calculatemi.svg": 2423,
	"./fisdom/calender-rs.svg": 1387,
	"./fisdom/call_back_confirm.png": 3379,
	"./fisdom/call_back_confirm.svg": 2424,
	"./fisdom/cancelled_sip_icon.svg": 2425,
	"./fisdom/card_upload_selfie.svg": 2426,
	"./fisdom/cas_not_received.svg": 2427,
	"./fisdom/cash-payment.svg": 1388,
	"./fisdom/certificate-rs.svg": 2428,
	"./fisdom/chat_bubble.svg": 1389,
	"./fisdom/circle_loader.gif": 2429,
	"./fisdom/complete_kyc.svg": 2430,
	"./fisdom/completed.svg": 1390,
	"./fisdom/completed_step.svg": 1391,
	"./fisdom/congrats.svg": 2431,
	"./fisdom/congratulations.svg": 2432,
	"./fisdom/congratulations_illustration.svg": 1059,
	"./fisdom/corpus_switch.svg": 1392,
	"./fisdom/crd_gold_info.svg": 1393,
	"./fisdom/cross.svg": 2433,
	"./fisdom/daily_exprenses_fisdom.svg": 2434,
	"./fisdom/dark_selfie.svg": 1394,
	"./fisdom/default.svg": 2435,
	"./fisdom/deliver.svg": 2436,
	"./fisdom/desktop_partner_landing_pnb.svg": 2437,
	"./fisdom/digilocker_failed.svg": 1395,
	"./fisdom/digilocker_kyc.svg": 1396,
	"./fisdom/diy_search_iframe.svg": 1397,
	"./fisdom/doc-uploaded.svg": 2438,
	"./fisdom/document.svg": 2439,
	"./fisdom/document_.svg": 2440,
	"./fisdom/down_arrow.svg": 2441,
	"./fisdom/down_arrow_fisdom.svg": 953,
	"./fisdom/download.svg": 2442,
	"./fisdom/eligibility.svg": 2443,
	"./fisdom/entry_insurance_advisory.svg": 1398,
	"./fisdom/eq_pg_success.svg": 2444,
	"./fisdom/equity_derivatives_transparent.svg": 2445,
	"./fisdom/error_illustration.svg": 818,
	"./fisdom/esign-kyc.svg": 1399,
	"./fisdom/esign_kyc_fail.svg": 1400,
	"./fisdom/exclamation.svg": 2446,
	"./fisdom/expense.svg": 1401,
	"./fisdom/experience.svg": 2447,
	"./fisdom/external_portfolio.svg": 2448,
	"./fisdom/failed_order_delivery.svg": 2449,
	"./fisdom/fd_partner_login.svg": 1402,
	"./fisdom/fisdom_logo.svg": 2450,
	"./fisdom/fisdom_logo_icon.svg": 2451,
	"./fisdom/fisdom_logo_icon_white.svg": 2452,
	"./fisdom/fisdom_logo_white.svg": 1403,
	"./fisdom/foreign-location.svg": 1404,
	"./fisdom/fpo.svg": 1405,
	"./fisdom/fpo_transparent.svg": 2453,
	"./fisdom/free_from_el_tag.png": 3488,
	"./fisdom/free_gold_etf.svg": 2454,
	"./fisdom/freedom.svg": 1406,
	"./fisdom/fund_details_cover.png": 3489,
	"./fisdom/fund_house_icon.png": 3490,
	"./fisdom/fundwise.svg": 2455,
	"./fisdom/fyntune_landing_page_hero.svg": 1407,
	"./fisdom/get_insured_carousel_1.svg": 2456,
	"./fisdom/get_insured_carousel_2.svg": 2457,
	"./fisdom/get_insured_carousel_3.svg": 2458,
	"./fisdom/go_to_gallery_green.svg": 1408,
	"./fisdom/goalwise.svg": 2459,
	"./fisdom/gold.svg": 2460,
	"./fisdom/gold_pattern.png": 3380,
	"./fisdom/group.svg": 1409,
	"./fisdom/growth.svg": 2461,
	"./fisdom/hand.svg": 1410,
	"./fisdom/home_insurance_icon.svg": 2462,
	"./fisdom/hourglass.svg": 1411,
	"./fisdom/ic-account.svg": 2463,
	"./fisdom/ic-added-pans.svg": 2464,
	"./fisdom/ic-clear-filter.svg": 2465,
	"./fisdom/ic-diversification.svg": 2466,
	"./fisdom/ic-dropdown.svg": 2467,
	"./fisdom/ic-email-sync.svg": 2468,
	"./fisdom/ic-emails.svg": 2469,
	"./fisdom/ic-filter.svg": 2470,
	"./fisdom/ic-fisdom-logo.jpg": 4176,
	"./fisdom/ic-fund-selection.svg": 2471,
	"./fisdom/ic-info-primary.svg": 2472,
	"./fisdom/ic-info.svg": 2473,
	"./fisdom/ic-investment-strategy.svg": 2474,
	"./fisdom/ic-mob-add-email.svg": 2475,
	"./fisdom/ic-mob-add-mail.svg": 2476,
	"./fisdom/ic-mob-add-pic.svg": 2477,
	"./fisdom/ic-mob-dropdown.svg": 2478,
	"./fisdom/ic-mob-emails.svg": 2479,
	"./fisdom/ic-mob-filter.svg": 2480,
	"./fisdom/ic-mob-logout.svg": 2481,
	"./fisdom/ic-mob-success.svg": 2482,
	"./fisdom/ic-mob-trust.svg": 2483,
	"./fisdom/ic-mobile-verification.svg": 2484,
	"./fisdom/ic-nav-analysis-active.svg": 2485,
	"./fisdom/ic-nav-analysis-inactive.svg": 2486,
	"./fisdom/ic-nav-holdings-active.svg": 2487,
	"./fisdom/ic-nav-holdings-inactive.svg": 2488,
	"./fisdom/ic-nav-overview-active.svg": 2489,
	"./fisdom/ic-nav-overview-inactive.svg": 2490,
	"./fisdom/ic-nav-taxation-active.svg": 2491,
	"./fisdom/ic-nav-taxation-inactive.svg": 2492,
	"./fisdom/ic-portfolio-composition.svg": 2493,
	"./fisdom/ic-portfolio-liquidity.svg": 2494,
	"./fisdom/ic-profile-avatar.svg": 2495,
	"./fisdom/ic-right-chevron.svg": 2496,
	"./fisdom/ic-secure.svg": 2497,
	"./fisdom/ic-tax-efficiency.svg": 2498,
	"./fisdom/ic_aadhaar_card.svg": 2499,
	"./fisdom/ic_aadhaar_handy.svg": 1412,
	"./fisdom/ic_address_details.svg": 2500,
	"./fisdom/ic_amfi_white.svg": 2501,
	"./fisdom/ic_auth_bank.svg": 2502,
	"./fisdom/ic_bank_added.svg": 2503,
	"./fisdom/ic_bank_not_added.svg": 2504,
	"./fisdom/ic_bank_not_rejected.svg": 1413,
	"./fisdom/ic_bank_partial_add.svg": 1414,
	"./fisdom/ic_bank_partial_added.svg": 1060,
	"./fisdom/ic_bank_verified.svg": 1415,
	"./fisdom/ic_benefit_gold.svg": 1416,
	"./fisdom/ic_bse_white.svg": 2505,
	"./fisdom/ic_btm_mail_check.svg": 2506,
	"./fisdom/ic_btm_sheet_high_returns.svg": 1417,
	"./fisdom/ic_buy_gold.svg": 2507,
	"./fisdom/ic_card_kyc_default.svg": 2508,
	"./fisdom/ic_card_kyc_pending.svg": 2509,
	"./fisdom/ic_card_kyc_underprocess.svg": 2510,
	"./fisdom/ic_customer_portal.svg": 2511,
	"./fisdom/ic_date_confirmed.svg": 1418,
	"./fisdom/ic_date_payment.svg": 1419,
	"./fisdom/ic_db_account.svg": 2512,
	"./fisdom/ic_db_help.svg": 2513,
	"./fisdom/ic_db_invest.svg": 2514,
	"./fisdom/ic_db_invest_solid.svg": 2515,
	"./fisdom/ic_db_kyc.svg": 2516,
	"./fisdom/ic_db_portfolio.svg": 2517,
	"./fisdom/ic_db_refer.svg": 2518,
	"./fisdom/ic_delivery.svg": 2519,
	"./fisdom/ic_diverse_pf.svg": 2520,
	"./fisdom/ic_document_amount.svg": 2521,
	"./fisdom/ic_document_card.svg": 2522,
	"./fisdom/ic_document_cash.svg": 2523,
	"./fisdom/ic_document_cloud.svg": 2524,
	"./fisdom/ic_document_copy.svg": 1061,
	"./fisdom/ic_document_location.svg": 1420,
	"./fisdom/ic_document_mobile.svg": 2525,
	"./fisdom/ic_document_note.svg": 2526,
	"./fisdom/ic_email.svg": 1421,
	"./fisdom/ic_encryption.svg": 2527,
	"./fisdom/ic_esign_done.svg": 2528,
	"./fisdom/ic_esign_done_fisdom.svg": 1062,
	"./fisdom/ic_esign_kyc.svg": 2529,
	"./fisdom/ic_esign_otp.svg": 2530,
	"./fisdom/ic_esign_otp_fisdom.svg": 1063,
	"./fisdom/ic_fin_tools_fhc.svg": 2531,
	"./fisdom/ic_fin_tools_risk.svg": 2532,
	"./fisdom/ic_get_money.svg": 2533,
	"./fisdom/ic_gold_added.svg": 2534,
	"./fisdom/ic_gold_provider.svg": 2535,
	"./fisdom/ic_help.svg": 2536,
	"./fisdom/ic_higher_returns.svg": 2537,
	"./fisdom/ic_how_to_claim.svg": 1422,
	"./fisdom/ic_how_to_claim2.svg": 1423,
	"./fisdom/ic_hs_cover_amount.svg": 1424,
	"./fisdom/ic_hs_cover_periods.svg": 1425,
	"./fisdom/ic_hs_insured.svg": 1426,
	"./fisdom/ic_hs_medical_checkup.svg": 2538,
	"./fisdom/ic_hs_pay_freq.svg": 1427,
	"./fisdom/ic_hs_policy.svg": 1428,
	"./fisdom/ic_indian_resident.svg": 2539,
	"./fisdom/ic_input.svg": 2540,
	"./fisdom/ic_input_65.svg": 2541,
	"./fisdom/ic_insta_fund_redemption.svg": 2542,
	"./fisdom/ic_instant.svg": 1429,
	"./fisdom/ic_instant_withdrawal.svg": 1430,
	"./fisdom/ic_intelligent_pf.svg": 2543,
	"./fisdom/ic_invest_build_wealth.svg": 2544,
	"./fisdom/ic_invest_explore_mf.svg": 2545,
	"./fisdom/ic_invest_gold.svg": 2546,
	"./fisdom/ic_invest_hundered_mf.svg": 2547,
	"./fisdom/ic_invest_insurance.svg": 2548,
	"./fisdom/ic_invest_learn.svg": 2549,
	"./fisdom/ic_invest_nfo.svg": 2550,
	"./fisdom/ic_invest_nps.svg": 2551,
	"./fisdom/ic_invest_save_tax.svg": 2552,
	"./fisdom/ic_ipo.svg": 2553,
	"./fisdom/ic_kyc_complete.svg": 2554,
	"./fisdom/ic_kyc_incomplete.svg": 2555,
	"./fisdom/ic_kyc_rejected.svg": 2556,
	"./fisdom/ic_kyc_under_process.svg": 2557,
	"./fisdom/ic_line.svg": 2558,
	"./fisdom/ic_loan_schedule.svg": 2559,
	"./fisdom/ic_locker.svg": 1431,
	"./fisdom/ic_low_risk.svg": 2560,
	"./fisdom/ic_mail.svg": 2561,
	"./fisdom/ic_make_payment.svg": 2562,
	"./fisdom/ic_medical_checkup.svg": 1432,
	"./fisdom/ic_medical_checkup2.svg": 1433,
	"./fisdom/ic_mobile.svg": 1434,
	"./fisdom/ic_next_arrow.svg": 2563,
	"./fisdom/ic_no_doc.svg": 1435,
	"./fisdom/ic_onetime.svg": 2564,
	"./fisdom/ic_pan_card.svg": 2565,
	"./fisdom/ic_personal_accident.svg": 2566,
	"./fisdom/ic_pf_gold.svg": 2567,
	"./fisdom/ic_pf_insurance.svg": 2568,
	"./fisdom/ic_pf_withdraw.svg": 2569,
	"./fisdom/ic_policy_period.svg": 1436,
	"./fisdom/ic_popup_kyc_pending.svg": 1064,
	"./fisdom/ic_popup_kyc_underprocess.svg": 2570,
	"./fisdom/ic_popup_kyc_verified.svg": 2571,
	"./fisdom/ic_popup_premium_onboarding_big.svg": 2572,
	"./fisdom/ic_premium_onboarding.svg": 2573,
	"./fisdom/ic_premium_onboarding_mid.svg": 2574,
	"./fisdom/ic_premium_onboarding_small.svg": 2575,
	"./fisdom/ic_process_done.svg": 1065,
	"./fisdom/ic_purity.svg": 1437,
	"./fisdom/ic_read.svg": 1438,
	"./fisdom/ic_risk_analyse.svg": 2576,
	"./fisdom/ic_save.svg": 1439,
	"./fisdom/ic_save_for_goal.svg": 2577,
	"./fisdom/ic_sebi.svg": 2578,
	"./fisdom/ic_sebi_transparent.svg": 2579,
	"./fisdom/ic_sec_basic_materials.svg": 2580,
	"./fisdom/ic_sec_chemicals.svg": 2581,
	"./fisdom/ic_sec_communication.svg": 2582,
	"./fisdom/ic_sec_cons_durable.svg": 2583,
	"./fisdom/ic_sec_consumer_cyclical.svg": 2584,
	"./fisdom/ic_sec_consumer_defensive.svg": 2585,
	"./fisdom/ic_sec_energy.svg": 2586,
	"./fisdom/ic_sec_finance.svg": 2587,
	"./fisdom/ic_sec_healthcare.svg": 2588,
	"./fisdom/ic_sec_industrials.svg": 2589,
	"./fisdom/ic_sec_others.svg": 2590,
	"./fisdom/ic_sec_real_estate.svg": 2591,
	"./fisdom/ic_sec_technology.svg": 2592,
	"./fisdom/ic_sec_utility.svg": 2593,
	"./fisdom/ic_secure_vault.svg": 1440,
	"./fisdom/ic_sell_gold.svg": 2594,
	"./fisdom/ic_short_term_inv.svg": 2595,
	"./fisdom/ic_sip.svg": 2596,
	"./fisdom/ic_sip_mandate_attention.svg": 2597,
	"./fisdom/ic_stocks.svg": 2598,
	"./fisdom/ic_term_insurance.svg": 2599,
	"./fisdom/ic_to_sell_gold.svg": 1441,
	"./fisdom/ic_upgrade.svg": 1442,
	"./fisdom/ic_verify_otp.svg": 2600,
	"./fisdom/ic_verify_otp_fisdom.svg": 1066,
	"./fisdom/ic_wallet.svg": 2601,
	"./fisdom/ic_whats_covered.svg": 1443,
	"./fisdom/ic_whats_not_covered.svg": 1444,
	"./fisdom/ic_whatsapp_failed.svg": 1445,
	"./fisdom/ic_whatsapp_small.svg": 2602,
	"./fisdom/ic_why_fyn1.png": 3381,
	"./fisdom/ic_why_fyn2.png": 3382,
	"./fisdom/ic_why_fyn3.png": 3383,
	"./fisdom/ic_why_hs.svg": 2603,
	"./fisdom/ic_why_hs2.svg": 2604,
	"./fisdom/ic_why_hs3.svg": 2605,
	"./fisdom/ic_why_hs4.svg": 2606,
	"./fisdom/ic_why_hs_gmc_1.svg": 2607,
	"./fisdom/ic_why_hs_gmc_2.svg": 2608,
	"./fisdom/ic_why_hs_gmc_3.svg": 2609,
	"./fisdom/ic_why_hs_loan.svg": 2610,
	"./fisdom/ic_why_loan.svg": 2611,
	"./fisdom/ic_why_loan1.svg": 2612,
	"./fisdom/ic_why_loan2.svg": 2613,
	"./fisdom/ic_why_loan3.svg": 2614,
	"./fisdom/ic_why_loan_3.svg": 2615,
	"./fisdom/ic_why_loan_4.svg": 2616,
	"./fisdom/ic_withdrawal.svg": 2617,
	"./fisdom/icn_Issue_loan.svg": 2618,
	"./fisdom/icn_ROI.svg": 2619,
	"./fisdom/icn_aadhaar_kyc.svg": 2620,
	"./fisdom/icn_aadhaar_kyc_small.svg": 1446,
	"./fisdom/icn_application_created.svg": 1447,
	"./fisdom/icn_assistance.svg": 1448,
	"./fisdom/icn_awaiting_period_fisdom.svg": 2621,
	"./fisdom/icn_b1_m.svg": 2622,
	"./fisdom/icn_b2_m.svg": 2623,
	"./fisdom/icn_b3_fisdom.svg": 2624,
	"./fisdom/icn_b3_m.svg": 2625,
	"./fisdom/icn_b4_m.svg": 2626,
	"./fisdom/icn_b_1.svg": 2627,
	"./fisdom/icn_b_2.svg": 2628,
	"./fisdom/icn_b_3.svg": 2629,
	"./fisdom/icn_bt_1.svg": 2630,
	"./fisdom/icn_bt_2.svg": 2631,
	"./fisdom/icn_bt_3.svg": 2632,
	"./fisdom/icn_ca.svg": 1449,
	"./fisdom/icn_contact.svg": 2633,
	"./fisdom/icn_couple.svg": 2634,
	"./fisdom/icn_crousal_card1.svg": 1450,
	"./fisdom/icn_crousal_card_1.svg": 2635,
	"./fisdom/icn_diseases_insurance.svg": 2636,
	"./fisdom/icn_end_date.svg": 1451,
	"./fisdom/icn_expert_match.svg": 2637,
	"./fisdom/icn_file_itr.svg": 2638,
	"./fisdom/icn_free.svg": 1452,
	"./fisdom/icn_fundwise_summary.svg": 1067,
	"./fisdom/icn_gold.svg": 2639,
	"./fisdom/icn_health_insurance.svg": 2640,
	"./fisdom/icn_hero.svg": 2641,
	"./fisdom/icn_hs_assistance.svg": 2642,
	"./fisdom/icn_hs_no_document.svg": 2643,
	"./fisdom/icn_hs_payment.svg": 2644,
	"./fisdom/icn_identity.svg": 1453,
	"./fisdom/icn_issue_date.svg": 1454,
	"./fisdom/icn_journey_start.svg": 2645,
	"./fisdom/icn_kids.svg": 2646,
	"./fisdom/icn_kyc_completed.svg": 2647,
	"./fisdom/icn_kyc_doc_rejected.svg": 2648,
	"./fisdom/icn_kyc_doc_verification.svg": 2649,
	"./fisdom/icn_kyc_incomplete.svg": 2650,
	"./fisdom/icn_life insurance.svg": 2651,
	"./fisdom/icn_loan_amnt.svg": 2652,
	"./fisdom/icn_lourney_end.svg": 2653,
	"./fisdom/icn_mail_id.svg": 1455,
	"./fisdom/icn_motor_insurance.svg": 2654,
	"./fisdom/icn_msg_sent.svg": 2655,
	"./fisdom/icn_notification.svg": 2656,
	"./fisdom/icn_nps.svg": 2657,
	"./fisdom/icn_ongoingcovid_fisdom.svg": 2658,
	"./fisdom/icn_online_support.svg": 2659,
	"./fisdom/icn_other_insurance.svg": 2660,
	"./fisdom/icn_parents.svg": 2661,
	"./fisdom/icn_payment_frequency.svg": 1456,
	"./fisdom/icn_phn_no.svg": 1457,
	"./fisdom/icn_plan_type.svg": 1458,
	"./fisdom/icn_policy_found_f.svg": 1459,
	"./fisdom/icn_quarantine_fisdom.svg": 2662,
	"./fisdom/icn_review_1.svg": 1460,
	"./fisdom/icn_review_2.svg": 1461,
	"./fisdom/icn_review_3.svg": 1462,
	"./fisdom/icn_review_edit.svg": 2663,
	"./fisdom/icn_review_file.svg": 2664,
	"./fisdom/icn_salaried.svg": 2665,
	"./fisdom/icn_satisfied_clients.svg": 2666,
	"./fisdom/icn_scroller_card1.svg": 1463,
	"./fisdom/icn_self_employed.svg": 2667,
	"./fisdom/icn_self_itr.svg": 1464,
	"./fisdom/icn_service_ratings.svg": 2668,
	"./fisdom/icn_start_date_1.svg": 1465,
	"./fisdom/icn_tax_filing.svg": 2669,
	"./fisdom/icn_tax_made_simple.svg": 2670,
	"./fisdom/icn_tax_statement.svg": 1466,
	"./fisdom/icn_time.svg": 1467,
	"./fisdom/icn_top_equity_funds.svg": 2671,
	"./fisdom/icn_travel_covid_fisdom.svg": 2672,
	"./fisdom/icn_upload_form_16.svg": 2673,
	"./fisdom/icn_zero_paper.svg": 1468,
	"./fisdom/icon_bull.svg": 1469,
	"./fisdom/icon_color.svg": 2674,
	"./fisdom/identity.svg": 2675,
	"./fisdom/identity_.svg": 2676,
	"./fisdom/idfc_card.svg": 2677,
	"./fisdom/ill_refer_earn.svg": 1470,
	"./fisdom/ils_alternate_assets.svg": 1471,
	"./fisdom/ils_covid_failed.svg": 2678,
	"./fisdom/ils_covid_failed_copy_2.svg": 2679,
	"./fisdom/ils_covid_pending.svg": 2680,
	"./fisdom/ils_covid_success.svg": 2681,
	"./fisdom/ils_digilocker_failed.svg": 1472,
	"./fisdom/ils_digilocker_success.svg": 2682,
	"./fisdom/ils_error.svg": 2683,
	"./fisdom/ils_esign_failed.svg": 1473,
	"./fisdom/ils_esign_kyc.svg": 1474,
	"./fisdom/ils_esign_success.svg": 2684,
	"./fisdom/ils_gold_purchase_failed.svg": 2685,
	"./fisdom/ils_gold_purchase_pending.svg": 2686,
	"./fisdom/ils_gold_purchase_success.svg": 2687,
	"./fisdom/ils_gold_sell_failed.svg": 2688,
	"./fisdom/ils_gold_sell_success.svg": 2689,
	"./fisdom/ils_hassle_free.svg": 1475,
	"./fisdom/ils_loan_approve.svg": 2690,
	"./fisdom/ils_loan_email.svg": 2691,
	"./fisdom/ils_loan_failed.svg": 2692,
	"./fisdom/ils_loan_intro_card.svg": 2693,
	"./fisdom/ils_loan_status.svg": 2694,
	"./fisdom/ils_login.svg": 819,
	"./fisdom/ils_no_data.svg": 2695,
	"./fisdom/ils_no_data_mob.svg": 2696,
	"./fisdom/ils_register.svg": 2697,
	"./fisdom/ils_timeout.svg": 1476,
	"./fisdom/ils_wip.svg": 2698,
	"./fisdom/ils_wip_mob.svg": 2699,
	"./fisdom/inactive-policy-background.svg": 1477,
	"./fisdom/inc_infected_fisdom.svg": 2700,
	"./fisdom/inc_outside_india_fisdom.svg": 2701,
	"./fisdom/income_.svg": 2702,
	"./fisdom/info_icon.svg": 950,
	"./fisdom/insurance_landing_hero.svg": 2703,
	"./fisdom/invest.svg": 1478,
	"./fisdom/invest_fund.svg": 1479,
	"./fisdom/invest_process.svg": 1480,
	"./fisdom/investment.svg": 2704,
	"./fisdom/ipo.svg": 1481,
	"./fisdom/ipo_transparent.svg": 2705,
	"./fisdom/irdanewlogo1.svg": 2706,
	"./fisdom/its_help.svg": 2707,
	"./fisdom/its_help_mob.svg": 2708,
	"./fisdom/iv_aadhar.svg": 1482,
	"./fisdom/iv_analyst_view.svg": 2709,
	"./fisdom/iv_close_demat.svg": 1483,
	"./fisdom/iv_closure_approved.svg": 2710,
	"./fisdom/iv_closure_pending.svg": 2711,
	"./fisdom/iv_closure_rejected.svg": 2712,
	"./fisdom/iv_closure_status.svg": 1484,
	"./fisdom/iv_earn_reward.svg": 1485,
	"./fisdom/iv_esign.svg": 1486,
	"./fisdom/iv_esign_top.svg": 1487,
	"./fisdom/iv_freedomplanIntro.svg": 2713,
	"./fisdom/iv_lock_in.svg": 2714,
	"./fisdom/iv_no_rewards.svg": 1488,
	"./fisdom/iv_otp.svg": 1489,
	"./fisdom/iv_profile.svg": 1490,
	"./fisdom/iv_profile_support.svg": 1491,
	"./fisdom/iv_refer_and_earn.svg": 2715,
	"./fisdom/iv_returns.svg": 2716,
	"./fisdom/iv_save_taxes.svg": 2717,
	"./fisdom/iv_thumbs_up_active.svg": 2718,
	"./fisdom/iv_upload_attachment.svg": 1492,
	"./fisdom/ivn_account_exists.svg": 1493,
	"./fisdom/ivn_gift_colored.svg": 2719,
	"./fisdom/kyc_complete_setup.svg": 2720,
	"./fisdom/kyc_default.svg": 2721,
	"./fisdom/kyc_error.svg": 2722,
	"./fisdom/kyc_esign.svg": 2723,
	"./fisdom/kyc_illust.svg": 1068,
	"./fisdom/kyc_inprogress.svg": 2724,
	"./fisdom/kyc_loader.gif": 3583,
	"./fisdom/kyc_rejected.svg": 2725,
	"./fisdom/kyc_status_icon.svg": 1494,
	"./fisdom/kyc_upgrade.svg": 2726,
	"./fisdom/landing_call_back_button.svg": 1495,
	"./fisdom/landing_customer_carousel_1.svg": 2727,
	"./fisdom/landing_customer_carousel_2.svg": 2728,
	"./fisdom/landing_customer_carousel_3.svg": 2729,
	"./fisdom/landing_step_verified.svg": 1496,
	"./fisdom/link_icon.svg": 1497,
	"./fisdom/loader_gif.gif": 1498,
	"./fisdom/loan.svg": 1499,
	"./fisdom/loan_hand.svg": 2730,
	"./fisdom/loan_icon.svg": 2731,
	"./fisdom/loan_success.svg": 2732,
	"./fisdom/lock_key.svg": 2733,
	"./fisdom/lottie/account_manage": 1500,
	"./fisdom/lottie/account_manage.json": 1500,
	"./fisdom/lottie/calendar": 1069,
	"./fisdom/lottie/calendar.json": 1069,
	"./fisdom/lottie/calender_complete": 1501,
	"./fisdom/lottie/calender_complete.json": 1501,
	"./fisdom/lottie/calender_error": 1502,
	"./fisdom/lottie/calender_error.json": 1502,
	"./fisdom/lottie/calender_paused": 1503,
	"./fisdom/lottie/calender_paused.json": 1503,
	"./fisdom/lottie/calender_reinvest": 1504,
	"./fisdom/lottie/calender_reinvest.json": 1504,
	"./fisdom/lottie/coin1": 1505,
	"./fisdom/lottie/coin1.json": 1505,
	"./fisdom/lottie/coin2": 1506,
	"./fisdom/lottie/coin2.json": 1506,
	"./fisdom/lottie/coin3": 1507,
	"./fisdom/lottie/coin3.json": 1507,
	"./fisdom/lottie/debt": 1508,
	"./fisdom/lottie/debt.json": 1508,
	"./fisdom/lottie/equity": 1509,
	"./fisdom/lottie/equity.json": 1509,
	"./fisdom/lottie/hybrid": 1510,
	"./fisdom/lottie/hybrid.json": 1510,
	"./fisdom/lottie/insights": 1511,
	"./fisdom/lottie/insights.json": 1511,
	"./fisdom/lottie/kyc_complete": 1070,
	"./fisdom/lottie/kyc_complete.json": 1070,
	"./fisdom/lottie/no_mf_order": 1071,
	"./fisdom/lottie/no_mf_order.json": 1071,
	"./fisdom/lottie/one_kyc": 1512,
	"./fisdom/lottie/one_kyc.json": 1512,
	"./fisdom/lottie/order_place": 1513,
	"./fisdom/lottie/order_place.json": 1513,
	"./fisdom/lottie/signfier": 1072,
	"./fisdom/lottie/signfier.json": 1072,
	"./fisdom/lottie/success_animation": 1073,
	"./fisdom/lottie/success_animation.json": 1073,
	"./fisdom/lottie/tick": 1074,
	"./fisdom/lottie/tick.json": 1074,
	"./fisdom/lottie/wallet": 1075,
	"./fisdom/lottie/wallet.json": 1075,
	"./fisdom/lottie/withdrawal": 1514,
	"./fisdom/lottie/withdrawal.json": 1514,
	"./fisdom/lottie/zero_investment": 1515,
	"./fisdom/lottie/zero_investment.json": 1515,
	"./fisdom/mandate_pending_icon.svg": 1076,
	"./fisdom/meter-aggressive.svg": 1516,
	"./fisdom/meter-conservative.svg": 1517,
	"./fisdom/meter-moderate.svg": 1518,
	"./fisdom/meter-moderately-aggressive.svg": 1519,
	"./fisdom/meter-moderately-conservative.svg": 1520,
	"./fisdom/mobile_credit_card.svg": 2734,
	"./fisdom/money_pig.svg": 2735,
	"./fisdom/more.svg": 2736,
	"./fisdom/mutual_fund.svg": 2737,
	"./fisdom/nav_right.svg": 1521,
	"./fisdom/ncd.svg": 1522,
	"./fisdom/ncd_transparent.svg": 2738,
	"./fisdom/next_arrow.svg": 2739,
	"./fisdom/no-filter-results.svg": 2740,
	"./fisdom/no_stocks_nri.svg": 1523,
	"./fisdom/nominee.svg": 1524,
	"./fisdom/not_eligible.svg": 2741,
	"./fisdom/nps.svg": 2742,
	"./fisdom/nps_report_icon.svg": 2743,
	"./fisdom/one_account.svg": 2744,
	"./fisdom/one_time_icn.svg": 2745,
	"./fisdom/order_id.svg": 1525,
	"./fisdom/order_placed_illustration.svg": 2746,
	"./fisdom/pan.svg": 2747,
	"./fisdom/pan_approved.svg": 2748,
	"./fisdom/pan_card.svg": 1526,
	"./fisdom/pan_default.svg": 2749,
	"./fisdom/pan_flash_on.svg": 2750,
	"./fisdom/pan_incorrect_placed.svg": 2751,
	"./fisdom/pan_sample_right.svg": 1527,
	"./fisdom/pan_verification_failed.svg": 2752,
	"./fisdom/paperless.svg": 2753,
	"./fisdom/passive_index.svg": 2754,
	"./fisdom/pause_cancel_sip.svg": 1528,
	"./fisdom/paused_sip_icon.svg": 2755,
	"./fisdom/payment_failed.svg": 2756,
	"./fisdom/payment_success.svg": 2757,
	"./fisdom/payment_transaction.svg": 2758,
	"./fisdom/pending.svg": 2759,
	"./fisdom/pending_order_delivery.svg": 2760,
	"./fisdom/pending_purchase.svg": 2761,
	"./fisdom/pending_redemption.svg": 2762,
	"./fisdom/people_sitting_fisdom.svg": 2763,
	"./fisdom/performance.svg": 2764,
	"./fisdom/personal.svg": 1529,
	"./fisdom/pg_success.svg": 2765,
	"./fisdom/pin_changed.svg": 820,
	"./fisdom/pointer_icon.svg": 1530,
	"./fisdom/policy_icon.svg": 1531,
	"./fisdom/popup_kyc_pending.svg": 2766,
	"./fisdom/portfolio_something_wrong.svg": 1532,
	"./fisdom/profile.svg": 1533,
	"./fisdom/rebalance_date.svg": 1534,
	"./fisdom/rebalance_pointer.svg": 1535,
	"./fisdom/rebalance_report.svg": 1536,
	"./fisdom/rec_point1.svg": 1537,
	"./fisdom/rec_point2.svg": 1538,
	"./fisdom/rec_point3.svg": 1539,
	"./fisdom/rec_point4.svg": 1540,
	"./fisdom/rec_point5.svg": 1541,
	"./fisdom/rec_point6.svg": 1542,
	"./fisdom/regi_approved.svg": 2767,
	"./fisdom/regi_default.svg": 2768,
	"./fisdom/register_icn.svg": 2769,
	"./fisdom/replace_bfdl.svg": 1543,
	"./fisdom/report_icon.svg": 1544,
	"./fisdom/reports_kyc_status.svg": 2770,
	"./fisdom/residence.svg": 2771,
	"./fisdom/returns.svg": 2772,
	"./fisdom/right_arrow.svg": 2773,
	"./fisdom/right_arrow_small.svg": 1545,
	"./fisdom/right_icon.svg": 2774,
	"./fisdom/right_selfie.svg": 1546,
	"./fisdom/risk_meter.svg": 2775,
	"./fisdom/risk_profile.svg": 1547,
	"./fisdom/rp_entry_banner.svg": 1548,
	"./fisdom/rp_intro_banner.svg": 1077,
	"./fisdom/safe_secure_journey.png": 3491,
	"./fisdom/salary.svg": 2776,
	"./fisdom/sbi.svg": 2777,
	"./fisdom/search.svg": 2778,
	"./fisdom/secure.svg": 1549,
	"./fisdom/secure_icon.svg": 2779,
	"./fisdom/selected.svg": 2780,
	"./fisdom/selfie_approved.svg": 2781,
	"./fisdom/selfie_default.svg": 2782,
	"./fisdom/selfie_placeholder.svg": 1550,
	"./fisdom/server_error_page.svg": 1551,
	"./fisdom/sgb.svg": 1552,
	"./fisdom/sgb_transparent.svg": 2783,
	"./fisdom/share_refer.svg": 2784,
	"./fisdom/shield.svg": 1553,
	"./fisdom/sign_approved.svg": 2785,
	"./fisdom/sign_default.svg": 2786,
	"./fisdom/singlebed_fisdom.svg": 2787,
	"./fisdom/sip.svg": 2788,
	"./fisdom/sip_action_illustration.svg": 1554,
	"./fisdom/sip_corpus_switch.svg": 1555,
	"./fisdom/sip_date.svg": 1556,
	"./fisdom/sip_date_icon.svg": 1078,
	"./fisdom/sip_icn.svg": 2789,
	"./fisdom/sip_resumed_illustration.svg": 2790,
	"./fisdom/sip_switch.svg": 1557,
	"./fisdom/start_recording.svg": 1558,
	"./fisdom/state_ipv_number.svg": 1559,
	"./fisdom/statements_briefcase.svg": 1079,
	"./fisdom/status_sip_icon.svg": 1560,
	"./fisdom/step_complete_check_icn.svg": 1561,
	"./fisdom/stocks_cip.svg": 2791,
	"./fisdom/successful_switch.svg": 1562,
	"./fisdom/sucess_order_delivery.svg": 2792,
	"./fisdom/surprised.svg": 1563,
	"./fisdom/switch_icon.svg": 1564,
	"./fisdom/team_tag.svg": 2793,
	"./fisdom/technology_funds.svg": 2794,
	"./fisdom/term_insurance.svg": 2795,
	"./fisdom/track_ext_pf.svg": 2796,
	"./fisdom/track_order.svg": 1565,
	"./fisdom/track_record.svg": 2797,
	"./fisdom/transactions.svg": 2798,
	"./fisdom/trend.svg": 2799,
	"./fisdom/trust_icon_registration.svg": 2800,
	"./fisdom/trust_icons.svg": 1080,
	"./fisdom/update_mobile.svg": 1566,
	"./fisdom/upload_doc_banner.svg": 1567,
	"./fisdom/upload_documents.svg": 1568,
	"./fisdom/upload_documents_pending.svg": 1569,
	"./fisdom/upload_error.svg": 2801,
	"./fisdom/upload_success.svg": 2802,
	"./fisdom/video_approved.svg": 2803,
	"./fisdom/video_default.svg": 2804,
	"./fisdom/video_uploaded_placeholder.svg": 1570,
	"./fisdom/whatsapp.svg": 1571,
	"./fisdom/wrong_selfie.svg": 1572,
	"./fno_course.svg": 2805,
	"./fpg.svg": 2806,
	"./fpo_banner.svg": 2807,
	"./freedomplan.svg": 2808,
	"./freedomplan_1.svg": 2809,
	"./full_name_dark_icn.png": 3298,
	"./full_name_icn.png": 3492,
	"./gender_dark_icn.png": 3493,
	"./gender_icn.png": 3494,
	"./generic_error.svg": 2810,
	"./generic_error2.svg": 2811,
	"./generic_green_right_arrow.svg": 1081,
	"./give_cash.svg": 1573,
	"./gmc_icn_landing_card_1.svg": 2812,
	"./gmc_icn_landing_card_2.svg": 2813,
	"./gmc_icn_landing_card_3.svg": 2814,
	"./go_to_gallery_green.svg": 965,
	"./go_to_gallery_grey.svg": 1574,
	"./gold_offer.jpg": 4177,
	"./gold_offer2.png": 3495,
	"./gold_offer_fisdom.jpg": 3584,
	"./gold_offer_fisdom3.jpg": 4178,
	"./gold_offer_myway.jpg": 4179,
	"./gold_offer_myway3.jpg": 4180,
	"./gold_pattern.png": 3496,
	"./google.svg": 2815,
	"./gpay.svg": 2816,
	"./grey_eye_icon.svg": 1575,
	"./group_12.svg": 2817,
	"./growth_icon.png": 3497,
	"./growth_journey_icon.png": 3498,
	"./hand.svg": 2818,
	"./hand_icon.png": 709,
	"./hbl.svg": 2819,
	"./hdfc_ergo_ic_logo_card.svg": 2820,
	"./hdfc_ergo_ic_logo_cta.svg": 2821,
	"./hdfc_ergo_ic_logo_summary.svg": 2822,
	"./hdfc_icn_landing_card_1.png": 3499,
	"./hdfc_icn_landing_card_2.png": 3500,
	"./hdfc_icn_landing_card_3.png": 3501,
	"./hdfc_insurance_logo.png": 3502,
	"./hdfc_insurance_small_logo.png": 3503,
	"./hdfc_logo.png": 3504,
	"./health_care_fund.svg": 2823,
	"./health_suraksha_fisdom.svg": 1576,
	"./health_suraksha_myway.svg": 1577,
	"./help.svg": 2824,
	"./help_fisdom.svg": 2825,
	"./help_myway.svg": 2826,
	"./hi-banner-image.svg": 1578,
	"./hide.png": 3505,
	"./high_growth.svg": 2827,
	"./home_insurance_fisdom.svg": 2828,
	"./home_insurance_icon_fisdom.svg": 2829,
	"./home_insurance_icon_myway.svg": 2830,
	"./home_insurance_myway.svg": 2831,
	"./how_it_works_1.png": 3506,
	"./how_it_works_2.png": 3507,
	"./how_it_works_3.png": 3508,
	"./hybrid.svg": 2832,
	"./ic-login-abstract.svg": 2833,
	"./ic-mob-back.svg": 2834,
	"./ic-star-green.svg": 2835,
	"./ic-star-red.svg": 2836,
	"./ic_analysis.svg": 2837,
	"./ic_auth_bank_fisdom.svg": 1082,
	"./ic_auth_emandate_fisdom.svg": 1083,
	"./ic_camera.svg": 2838,
	"./ic_care.svg": 1579,
	"./ic_ci_b1_fisdom.svg": 1580,
	"./ic_ci_b1_myway.svg": 1581,
	"./ic_ci_b3_fisdom.svg": 1582,
	"./ic_ci_b3_myway.svg": 1583,
	"./ic_ci_d1_fisdom.svg": 1584,
	"./ic_ci_d1_myway.svg": 1585,
	"./ic_claim_assist_fisdom.svg": 1586,
	"./ic_claim_assist_myway.svg": 1587,
	"./ic_claim_b2_fisdom.svg": 1588,
	"./ic_claim_b2_myway.svg": 1589,
	"./ic_clip.svg": 2839,
	"./ic_close.svg": 2840,
	"./ic_close_white.svg": 2841,
	"./ic_completed.svg": 2842,
	"./ic_coronavirus_insurance_fisdom.svg": 2843,
	"./ic_coronavirus_insurance_myway.svg": 2844,
	"./ic_covid_b_1_fisdom.svg": 1590,
	"./ic_covid_b_1_myway.svg": 1591,
	"./ic_covid_b_2_fisdom.svg": 1592,
	"./ic_covid_b_2_myway.svg": 1593,
	"./ic_covid_b_3_fisdom.svg": 1594,
	"./ic_covid_b_3_myway.svg": 1595,
	"./ic_covid_waiting_period_fisdom.svg": 1596,
	"./ic_covid_waiting_period_myway.svg": 1597,
	"./ic_dashboard.svg": 2845,
	"./ic_dealer_support.svg": 821,
	"./ic_dengue_insurance_fisdom.svg": 2846,
	"./ic_dengue_insurance_myway.svg": 2847,
	"./ic_discount.svg": 1084,
	"./ic_down_arrow_purple.svg": 2848,
	"./ic_esign_done_minvest.svg": 2849,
	"./ic_esign_otp_minvest.svg": 2850,
	"./ic_esign_otp_myway.svg": 2851,
	"./ic_gallery.svg": 2852,
	"./ic_gov_meit.svg": 984,
	"./ic_hand_insurance_fisdom.svg": 2853,
	"./ic_hand_insurance_myway.svg": 2854,
	"./ic_hdfc_logo.svg": 2855,
	"./ic_health_b1_fisdom.svg": 1598,
	"./ic_health_b1_myway.svg": 1599,
	"./ic_health_fisdom.svg": 2856,
	"./ic_health_myway.svg": 2857,
	"./ic_hi_b1_fisdom.svg": 1600,
	"./ic_hi_b1_myway.svg": 1601,
	"./ic_hi_b2_fisdom.svg": 1602,
	"./ic_hi_b2_myway.svg": 1603,
	"./ic_hi_b3_fisdom.svg": 1604,
	"./ic_hi_b3_myway.svg": 1605,
	"./ic_hi_b4_fisdom.svg": 1606,
	"./ic_hi_b4_myway.svg": 1607,
	"./ic_hi_b5_fisdom.svg": 1608,
	"./ic_hi_b5_myway.svg": 1609,
	"./ic_hi_b6_fisdom.svg": 1610,
	"./ic_hi_b6_myway.svg": 1611,
	"./ic_holding.svg": 2858,
	"./ic_hospicash_b1_fisdom.svg": 1612,
	"./ic_hospicash_b1_myway.svg": 1613,
	"./ic_hospicash_b2_fisdom.svg": 1085,
	"./ic_hospicash_b2_myway.svg": 1086,
	"./ic_hospicash_b3_fisdom.svg": 2859,
	"./ic_hospicash_b3_myway.svg": 2860,
	"./ic_hospicash_b4_fisdom.svg": 985,
	"./ic_hospicash_b4_myway.svg": 986,
	"./ic_hospicash_fisdom.svg": 2861,
	"./ic_hospicash_myway.svg": 2862,
	"./ic_how_to_claim_fisdom.svg": 1614,
	"./ic_how_to_claim_myway.svg": 1615,
	"./ic_hs_b1_fisdom.svg": 1616,
	"./ic_hs_b1_myway.svg": 1617,
	"./ic_hs_b2_fisdom.svg": 1618,
	"./ic_hs_b2_myway.svg": 1619,
	"./ic_hs_b3_fisdom.svg": 1620,
	"./ic_hs_b3_myway.svg": 1621,
	"./ic_hs_b4_fisdom.svg": 1622,
	"./ic_hs_b4_myway.svg": 1623,
	"./ic_hs_b5_fisdom.svg": 1624,
	"./ic_hs_b5_myway.svg": 1625,
	"./ic_hs_main.svg": 1087,
	"./ic_hs_main_benefits.svg": 987,
	"./ic_hs_special.svg": 1088,
	"./ic_hs_special_benefits.svg": 988,
	"./ic_input_fisdom.svg": 1626,
	"./ic_live_green.svg": 1627,
	"./ic_live_red.svg": 2863,
	"./ic_loan_sdk2.png": 3509,
	"./ic_logo_card.jpg": 4181,
	"./ic_negative.svg": 2864,
	"./ic_notification.svg": 639,
	"./ic_notification_badge.svg": 640,
	"./ic_pa_b1_fisdom.svg": 989,
	"./ic_pa_b1_myway.svg": 990,
	"./ic_pa_b2_fisdom.svg": 1628,
	"./ic_pa_b2_myway.svg": 1629,
	"./ic_pa_b3_fisdom.svg": 1630,
	"./ic_pa_b3_myway.svg": 1631,
	"./ic_pa_b4_fisdom.svg": 1632,
	"./ic_pa_b4_myway.svg": 1633,
	"./ic_pa_b5_fisdom.svg": 1634,
	"./ic_pa_b5_myway.svg": 1635,
	"./ic_pa_b6_fisdom.svg": 1636,
	"./ic_pa_b6_myway.svg": 1637,
	"./ic_pa_b7_fisdom.svg": 1638,
	"./ic_pa_b7_myway.svg": 1639,
	"./ic_personal_accident_fisdom.svg": 2865,
	"./ic_personal_accident_myway.svg": 2866,
	"./ic_positive.svg": 2867,
	"./ic_read_fisdom.svg": 1640,
	"./ic_read_myway.svg": 1641,
	"./ic_recommend.svg": 2868,
	"./ic_religare_logo.svg": 2869,
	"./ic_religare_logo_card.svg": 2870,
	"./ic_secure_right.png": 3384,
	"./ic_select_bank_fisdom.svg": 1089,
	"./ic_select_bank_myway.svg": 1090,
	"./ic_send_email.svg": 1091,
	"./ic_setting_active.svg": 641,
	"./ic_st_b3_fisdom.svg": 1642,
	"./ic_st_b3_myway.svg": 1643,
	"./ic_star.svg": 1092,
	"./ic_star_health.svg": 1644,
	"./ic_star_logo.svg": 2871,
	"./ic_star_logo_card.svg": 2872,
	"./ic_statement.svg": 2873,
	"./ic_term_insurance_fisdom.svg": 2874,
	"./ic_term_insurance_myway.svg": 2875,
	"./ic_trade_unlimited.svg": 822,
	"./ic_trust.png": 3510,
	"./ic_up_arrow_purple.svg": 2876,
	"./ic_user.svg": 2877,
	"./ic_verfication_in_progress.gif": 3511,
	"./ic_verify_otp_minvest.svg": 2878,
	"./ic_wallet_b1_fisdom.svg": 1645,
	"./ic_wallet_b1_myway.svg": 1646,
	"./ic_wallet_b2_fisdom.svg": 1647,
	"./ic_wallet_b2_myway.svg": 1648,
	"./ic_wallet_b3_fisdom.svg": 1649,
	"./ic_wallet_b3_myway.svg": 1650,
	"./ic_wallet_b4_fisdom.svg": 1651,
	"./ic_wallet_b4_myway.svg": 1652,
	"./ic_wallet_fisdom.svg": 2879,
	"./ic_wallet_myway.svg": 2880,
	"./ic_whats_covered_fisdom.svg": 1653,
	"./ic_whats_covered_myway.svg": 1654,
	"./ic_whats_not_covered_fisdom.svg": 1655,
	"./ic_whats_not_covered_myway.svg": 1656,
	"./ic_zero_brokerage.svg": 823,
	"./icici_fund.svg": 2881,
	"./icici_insurance_logo.png": 3512,
	"./icici_insurance_small_logo.png": 3513,
	"./icn_all_expenses_covid_fisdom.svg": 1657,
	"./icn_all_expenses_covid_myway.svg": 1658,
	"./icn_calculator.svg": 2882,
	"./icn_call_fisdom.svg": 1659,
	"./icn_call_myway.svg": 1660,
	"./icn_corona_finity.svg": 2883,
	"./icn_corona_fisdom.svg": 2884,
	"./icn_critical_illness_finity.svg": 2885,
	"./icn_critical_illness_fisdom.svg": 2886,
	"./icn_debit_card.svg": 1661,
	"./icn_dengue_finity.svg": 2887,
	"./icn_dengue_fisdom.svg": 2888,
	"./icn_gpay.svg": 1093,
	"./icn_health_insurance_finity.svg": 2889,
	"./icn_health_insurance_fisdom.svg": 2890,
	"./icn_icmr_covid_fisdom.svg": 1662,
	"./icn_icmr_covid_myway.svg": 1663,
	"./icn_infection_covid_fisdom.svg": 1664,
	"./icn_infection_covid_myway.svg": 1665,
	"./icn_life insurance_finity.svg": 2891,
	"./icn_life insurance_fisdom.svg": 2892,
	"./icn_more.svg": 966,
	"./icn_my_itr.svg": 1666,
	"./icn_old_age_covid_fisdom.svg": 1667,
	"./icn_old_age_covid_myway.svg": 1668,
	"./icn_ongoing_trtmnt_covid_fisdom.svg": 2893,
	"./icn_ongoing_trtmnt_covid_myway.svg": 2894,
	"./icn_other_insurance_finity.svg": 2895,
	"./icn_other_insurance_fisdom.svg": 2896,
	"./icn_outside_india_fisdom.svg": 1669,
	"./icn_outside_india_myway.svg": 1670,
	"./icn_paytm.svg": 1094,
	"./icn_phonepe.svg": 1095,
	"./icn_quarantined_covid_fisdom.svg": 1671,
	"./icn_quarantined_covid_myway.svg": 1672,
	"./icn_secure_payment.svg": 991,
	"./icn_secure_safe.svg": 2897,
	"./icn_tax_savings.svg": 2898,
	"./icn_travel_covid_fisdom.svg": 1673,
	"./icn_travel_covid_myway.svg": 1674,
	"./icn_upi_apps.svg": 1096,
	"./icon_search.svg": 542,
	"./idbi_trustee2.png": 3385,
	"./idfc.svg": 2899,
	"./idfc_logo.svg": 2900,
	"./iframe_back.svg": 518,
	"./iframe_close.svg": 642,
	"./ils_covid_failed_fisdom.svg": 1675,
	"./ils_covid_failed_myway.svg": 1676,
	"./ils_covid_success_fisdom.svg": 1677,
	"./ils_covid_success_myway.svg": 1678,
	"./ils_esign_failed_fisdom.svg": 1679,
	"./ils_esign_success_fisdom.svg": 1680,
	"./in_process_icn.png": 3514,
	"./income_icon.png": 3313,
	"./incorrect_otm_sample_image.svg": 1681,
	"./incr_arrow.svg": 2901,
	"./indb.svg": 2902,
	"./indb_bank.svg": 2903,
	"./indb_desktop.svg": 2904,
	"./info.svg": 954,
	"./info_icon.svg": 2905,
	"./info_icon_ds.svg": 935,
	"./info_icon_fisdom.svg": 967,
	"./info_icon_grey.svg": 1097,
	"./innovative_products_icon.png": 3515,
	"./inprogress_icon.svg": 2906,
	"./insta_redeem.svg": 2907,
	"./instant_fisdom.svg": 1098,
	"./instant_myway.svg": 1099,
	"./insurance_report_icon.png": 3516,
	"./interesting_themes_icon.png": 3517,
	"./internet_banking_icon.svg": 1100,
	"./intro_gold@2x.png": 3518,
	"./invest.png": 710,
	"./invest_directly.svg": 2908,
	"./invest_goal.svg": 2909,
	"./invest_in_mf_banner.svg": 2910,
	"./invest_with_confidence.svg": 2911,
	"./invested_amount.png": 3519,
	"./investment_contra.svg": 2912,
	"./investment_focused.svg": 2913,
	"./investment_idea1.svg": 2914,
	"./investment_objective.svg": 2915,
	"./io_insurance.svg": 2916,
	"./ipo.svg": 2917,
	"./ipo1.svg": 2918,
	"./ipo_banner.svg": 2919,
	"./irdanewlogo1.svg": 1682,
	"./itr.svg": 2920,
	"./itr_filing.svg": 2921,
	"./iv_add.svg": 1683,
	"./iv_announcement.svg": 2922,
	"./iv_arrow_right.svg": 936,
	"./iv_attachment.svg": 1101,
	"./iv_badge_failed.svg": 2923,
	"./iv_badge_pending.svg": 1684,
	"./iv_badge_successfull.svg": 1685,
	"./iv_buildwealth.svg": 2924,
	"./iv_chat_attachment.svg": 1102,
	"./iv_checked_green.svg": 2925,
	"./iv_childs_education.svg": 2926,
	"./iv_childs_wedding.svg": 2927,
	"./iv_close.svg": 992,
	"./iv_closure_option.svg": 1686,
	"./iv_debt.svg": 2928,
	"./iv_delete.svg": 1103,
	"./iv_document.svg": 2929,
	"./iv_down.svg": 968,
	"./iv_down_green.svg": 2930,
	"./iv_edit.svg": 2931,
	"./iv_elss.svg": 2932,
	"./iv_failed_reason.svg": 1687,
	"./iv_free_demat.svg": 2933,
	"./iv_info_failed.svg": 1688,
	"./iv_info_icon.svg": 1689,
	"./iv_my_queries.svg": 1690,
	"./iv_negative.svg": 2934,
	"./iv_order_cancelled.svg": 2935,
	"./iv_order_inprogress.svg": 2936,
	"./iv_order_successful.svg": 2937,
	"./iv_others.svg": 2938,
	"./iv_positive.svg": 2939,
	"./iv_refer_earn_landing.svg": 1691,
	"./iv_referrals.svg": 2940,
	"./iv_retirement.svg": 2941,
	"./iv_rewards.svg": 2942,
	"./iv_right_grey.svg": 969,
	"./iv_savings.svg": 2943,
	"./iv_share_contacts.svg": 2944,
	"./iv_share_mail.svg": 1692,
	"./iv_smallcase.svg": 2945,
	"./iv_stocks_sip.svg": 2946,
	"./iv_switch.svg": 1693,
	"./iv_thumbs_up.svg": 1694,
	"./iv_upi.svg": 1695,
	"./iv_vacation.svg": 2947,
	"./iv_wallet.svg": 2948,
	"./iv_whatsapp.svg": 2949,
	"./iv_whatsapp2.svg": 1104,
	"./ivn_account.svg": 2950,
	"./ivn_account_exists.svg": 2951,
	"./ivn_active.svg": 2952,
	"./ivn_add.svg": 2953,
	"./ivn_alert_colored.svg": 2954,
	"./ivn_avatar.svg": 2955,
	"./ivn_bank.svg": 2956,
	"./ivn_bull.svg": 2957,
	"./ivn_cancel.svg": 2958,
	"./ivn_copy.svg": 2959,
	"./ivn_down_arrow.svg": 1105,
	"./ivn_email.svg": 2960,
	"./ivn_facebook.svg": 2961,
	"./ivn_follow.svg": 2962,
	"./ivn_in_progress.svg": 2963,
	"./ivn_info.svg": 1106,
	"./ivn_instagram.svg": 2964,
	"./ivn_investment.svg": 2965,
	"./ivn_invite.svg": 2966,
	"./ivn_nominee.svg": 2967,
	"./ivn_onePercentAcademy.svg": 2968,
	"./ivn_profile.svg": 2969,
	"./ivn_referral.svg": 2970,
	"./ivn_right_arrow.svg": 2971,
	"./ivn_security_icon.svg": 2972,
	"./ivn_setting.svg": 2973,
	"./ivn_statement.svg": 2974,
	"./ivn_subtract.svg": 2975,
	"./ivn_telegram.svg": 2976,
	"./ivn_twitter.svg": 2977,
	"./ivn_up_arrow.svg": 1107,
	"./ivn_upload.svg": 2978,
	"./ivn_verified_green.svg": 2979,
	"./ivn_wallet.svg": 2980,
	"./ivn_youtube.svg": 2981,
	"./karvy_email.png": 3386,
	"./know_more_new.png": 3387,
	"./kotak-life-insurance.svg": 2982,
	"./kotak_life_logo.png": 3388,
	"./ktb.svg": 2983,
	"./ktb_bank.svg": 2984,
	"./kyc.svg": 2985,
	"./kyc_banner.svg": 2986,
	"./kyc_complete.svg": 993,
	"./kyc_icon.svg": 1696,
	"./large_cap.svg": 2987,
	"./large_mid_cap.svg": 2988,
	"./large_morning_star.svg": 2989,
	"./launch.svg": 1697,
	"./lavish_edu.png": 3389,
	"./lavish_wedding.png": 3390,
	"./left_arrow.svg": 2990,
	"./life_cover_icon.png": 3307,
	"./life_insurance_fisdom.svg": 2991,
	"./life_insurance_myway.svg": 2992,
	"./limo.png": 3391,
	"./link_icon.svg": 2993,
	"./loader_gif_fisdom.gif": 3585,
	"./location.png": 3520,
	"./location_dark_icn.png": 3293,
	"./location_icn.png": 3521,
	"./lock_icn.svg": 1108,
	"./locked_suit.svg": 1109,
	"./logo_highres_f.svg": 2994,
	"./logo_idbi.svg": 1698,
	"./logo_lbma.svg": 1699,
	"./logo_mmtc.svg": 643,
	"./logo_morningstar.svg": 1700,
	"./logo_safegold.svg": 644,
	"./logo_tax2win.svg": 1701,
	"./logout.png": 1110,
	"./logout_grey.png": 711,
	"./lottie/calander_complete": 1111,
	"./lottie/calander_complete.json": 1111,
	"./lottie/loader": 1112,
	"./lottie/loader.json": 1112,
	"./lottie/negative": 1113,
	"./lottie/negative.json": 1113,
	"./lottie/payment_cancel": 1114,
	"./lottie/payment_cancel.json": 1114,
	"./lottie/positive": 1115,
	"./lottie/positive.json": 1115,
	"./lottie/success": 1116,
	"./lottie/success.json": 1116,
	"./low_nav_icon.png": 3522,
	"./lvb.png": 3523,
	"./lvb.svg": 2995,
	"./male_icon.svg": 1702,
	"./marital_status_dark_icn.png": 3299,
	"./marital_status_icn.png": 3524,
	"./mb_4.svg": 2996,
	"./mb_5.svg": 2997,
	"./mb_6.svg": 2998,
	"./mf.svg": 2999,
	"./mf_goal_tracker.svg": 1703,
	"./mf_series.svg": 3000,
	"./mf_sip.svg": 1704,
	"./mf_withdraw.svg": 1705,
	"./mf_your_funds.svg": 1706,
	"./mf_your_orders.svg": 1707,
	"./mi_pay.svg": 1117,
	"./minus.svg": 3001,
	"./minus_icon.svg": 1118,
	"./minvest/ils_esign_failed.svg": 1708,
	"./minvest/ils_esign_kyc.svg": 1709,
	"./minvest/ils_esign_success.svg": 3002,
	"./minvest/loader_gif.gif": 3003,
	"./missed_sip.svg": 1119,
	"./mobikwik.svg": 1120,
	"./mobile_verification.svg": 3004,
	"./money_market_aggresive.svg": 3005,
	"./money_market_conservative.svg": 3006,
	"./money_market_custom.svg": 3007,
	"./money_market_moderate.svg": 3008,
	"./moneycontrol_logo.svg": 824,
	"./moneycontrol_sdk_logo.svg": 3009,
	"./monthly_sip_icon_dark.png": 3392,
	"./more.svg": 1710,
	"./more_vertical.svg": 1711,
	"./morning_star_logo.png": 3325,
	"./morning_star_small.svg": 1121,
	"./morning_text.png": 3393,
	"./mother_dark_icn.png": 3394,
	"./mother_icn.png": 3525,
	"./multi_cap.svg": 3010,
	"./my_nominee_icon.svg": 3011,
	"./myaccount.png": 712,
	"./myway/get_insured_carousel_1.svg": 3012,
	"./myway/get_insured_carousel_2.svg": 3013,
	"./myway/get_insured_carousel_3.svg": 3014,
	"./myway/icn_health_insurance_f.svg": 3015,
	"./myway/icn_life insurance_f.svg": 3016,
	"./myway/icn_motor_insurance_f.svg": 3017,
	"./myway/icn_other_insurance_f.svg": 3018,
	"./myway/insurance_landing_hero.svg": 3019,
	"./myway/landing_customer_carousel_1.svg": 3020,
	"./myway/landing_customer_carousel_2.svg": 3021,
	"./myway/landing_customer_carousel_3.svg": 3022,
	"./name_present_employer_dark_icn.png": 3395,
	"./name_present_employer_icn.png": 3526,
	"./nav_back.svg": 514,
	"./nav_close.svg": 540,
	"./negative_return.svg": 3023,
	"./new_fund.svg": 3024,
	"./new_fund_offer.svg": 3025,
	"./next_arrow.png": 600,
	"./next_arrow.svg": 3026,
	"./next_arrow_icon.svg": 3027,
	"./next_nav_bar_icon.svg": 3028,
	"./next_step_icon.png": 3527,
	"./nfo.svg": 3029,
	"./nfo1.svg": 3030,
	"./nfo_info_cover.png": 3396,
	"./nifty.svg": 3031,
	"./no_internet_connection_icon.png": 3528,
	"./no_lock_in_icon.png": 3397,
	"./no_mf_orders.svg": 3032,
	"./no_smoke_icon.png": 3398,
	"./nominee.png": 3529,
	"./norton_secured_icon.png": 3399,
	"./not_done_yet_step.svg": 1122,
	"./not_selected.svg": 3033,
	"./notification.svg": 1712,
	"./notification_badge_red.svg": 1713,
	"./notifications_icon_red.png": 3530,
	"./notifications_icon_with_dot.svg": 645,
	"./notifications_icon_without_dot.svg": 646,
	"./nps.svg": 3034,
	"./nps_asset_allocation_icon.png": 3400,
	"./nps_one_time_icon.svg": 1714,
	"./nps_regulated_icon.png": 3401,
	"./nps_retirement_icon.png": 3402,
	"./nps_save_tax_icon.png": 3403,
	"./nps_sip_icon.svg": 1715,
	"./nsdl.svg": 1716,
	"./obc.png": 3531,
	"./obc.svg": 3035,
	"./occupation_details_dark_icn.png": 3326,
	"./occupation_details_icn.png": 3532,
	"./one_investment_account.svg": 3036,
	"./one_time_icn_light.png": 3533,
	"./one_time_icon_dark.png": 3404,
	"./or_line.png": 3534,
	"./other_goal_icon.png": 3405,
	"./other_options.svg": 3037,
	"./others.svg": 3038,
	"./padlock1.svg": 713,
	"./pan_card_icon.png": 3535,
	"./pan_dark_icn.png": 3406,
	"./pan_icn.png": 3536,
	"./paperclip.svg": 1123,
	"./park_money.svg": 3039,
	"./passbook_first_page.svg": 3040,
	"./paused.svg": 3041,
	"./paused_icon.svg": 3042,
	"./payment.png": 3407,
	"./pdf_icon.svg": 3043,
	"./person.png": 3537,
	"./personal_details_icn.svg": 955,
	"./personal_details_icon.svg": 938,
	"./personal_finance.svg": 3044,
	"./pf_insurance.svg": 1717,
	"./phone_black.png": 3538,
	"./phone_dark_icn.png": 3314,
	"./phone_icn.png": 3539,
	"./picks_of_the_week.svg": 3045,
	"./pickup.png": 3327,
	"./piggy_bank@4x.png": 3328,
	"./plane.png": 3408,
	"./plant.svg": 3046,
	"./plus.svg": 3047,
	"./plus_icon.svg": 1124,
	"./pnb.png": 3540,
	"./pnb_logo.svg": 3048,
	"./portfolio.svg": 3049,
	"./portfolio_landing_banner.svg": 3050,
	"./portfolio_no_investment.svg": 994,
	"./positive_return.svg": 3051,
	"./premium.svg": 3052,
	"./premium_icon.svg": 1718,
	"./process_success.png": 3541,
	"./professional_details_icn.svg": 1125,
	"./professional_details_icon.svg": 1126,
	"./promo_code.png": 714,
	"./provider.svg": 3053,
	"./quesscorp.svg": 3054,
	"./rating1.png": 3409,
	"./rating2.png": 3410,
	"./rating3.png": 3411,
	"./rating4.png": 3412,
	"./rating5.png": 3413,
	"./recommended_tag_icon.svg": 1719,
	"./refer_and_earn.svg": 3055,
	"./refer_earn_menu_icon.png": 715,
	"./refer_gift_icon.png": 3414,
	"./referal.png": 1127,
	"./refresh.svg": 1720,
	"./registration_menu_icon.png": 3542,
	"./relationship.png": 3543,
	"./relationship_dark_icn.png": 3329,
	"./relationship_icn.png": 3544,
	"./religare_icn_landing_card_1.png": 3545,
	"./religare_icn_landing_card_2.png": 3546,
	"./religare_icn_landing_card_3.png": 3547,
	"./remove_cart_icon.png": 3415,
	"./replace_bfdl.png": 3548,
	"./reports.png": 716,
	"./restart_nav_icn.svg": 519,
	"./resume_redirection.png": 3416,
	"./resume_tag.png": 3549,
	"./retirement.svg": 3056,
	"./retirement_fund_icon.png": 3417,
	"./right_arrow.svg": 3057,
	"./right_arrow_secondary.svg": 3058,
	"./right_icon.svg": 995,
	"./risk.svg": 3059,
	"./risk_icon_aggressive.svg": 3060,
	"./risk_icon_conservative.svg": 3061,
	"./risk_icon_custom.svg": 3062,
	"./risk_icon_moderate.svg": 3063,
	"./risk_value_1.png": 3418,
	"./risk_value_2.png": 3419,
	"./risk_value_3.png": 3420,
	"./risk_value_4.png": 3421,
	"./risk_value_5.png": 3422,
	"./risk_value_6.png": 3423,
	"./safegold_logo@2x.png": 3424,
	"./safegold_logo_60x60.png": 3550,
	"./salary_slip.svg": 3064,
	"./sale.svg": 1721,
	"./samsung_pay.svg": 1128,
	"./sbm.svg": 3065,
	"./sbnri.svg": 3066,
	"./scooter.png": 3425,
	"./search.png": 3551,
	"./search_diy.svg": 939,
	"./search_icon.svg": 1722,
	"./sebi-logo.svg": 996,
	"./sebi.svg": 3067,
	"./sebi_logo.svg": 717,
	"./sebi_registered_logo.svg": 1129,
	"./secure.svg": 1130,
	"./secure_family_fisdom.svg": 3068,
	"./secure_family_myway.svg": 3069,
	"./secure_safe.svg": 3070,
	"./secure_your_loved_one_icon.png": 3552,
	"./security.svg": 3071,
	"./selected.png": 3553,
	"./selected.svg": 3072,
	"./selected_option.png": 3300,
	"./sell_gold_icon@2x.png": 3554,
	"./send_icon.png": 3426,
	"./sensex.svg": 3073,
	"./show.png": 3555,
	"./shrink_icn.png": 3291,
	"./sign_icon.svg": 3074,
	"./signature_icon.svg": 1131,
	"./simple_edu.png": 3427,
	"./simple_wedding.png": 3428,
	"./single_star.png": 3330,
	"./sip_action_illustration_fisdom.svg": 1132,
	"./sip_icn_light.png": 3556,
	"./sip_resumed_illustration_fisdom.svg": 1133,
	"./slider_arrow.svg": 3075,
	"./small_cap.svg": 3076,
	"./small_heart.svg": 1723,
	"./small_morning_star.svg": 3077,
	"./smoking_icon.png": 3315,
	"./split.svg": 3078,
	"./ssl_icon.png": 3429,
	"./ssl_icon_new.svg": 1134,
	"./star_icn_landing_card_1.svg": 3079,
	"./star_icn_landing_card_2.svg": 3080,
	"./star_icn_landing_card_3.svg": 3081,
	"./star_large.svg": 1724,
	"./star_silver.svg": 3082,
	"./stock_icon.png": 3430,
	"./stocks.svg": 3083,
	"./stocks_banner.svg": 3084,
	"./stopwatch.png": 3557,
	"./sub_icon.svg": 1725,
	"./subh.svg": 3085,
	"./success_icon.svg": 3086,
	"./successfull.svg": 3087,
	"./super_topup_fisdom.svg": 3088,
	"./super_topup_myway.svg": 3089,
	"./surplus_graph.png": 3558,
	"./suryoday.svg": 3090,
	"./svc.png": 3559,
	"./svc.svg": 3091,
	"./switch_arrow.svg": 3092,
	"./switch_arrow_down.svg": 1726,
	"./switch_icon.png": 3560,
	"./system_withdraw_icn.png": 3431,
	"./tag_star.svg": 1135,
	"./take_pic_green.svg": 970,
	"./take_pic_grey.svg": 1727,
	"./tax_banner.svg": 3093,
	"./tax_calculator.svg": 3094,
	"./tax_filing.svg": 3095,
	"./tax_filing_banner.svg": 3096,
	"./tax_icon@4x.png": 3561,
	"./tax_save.svg": 3097,
	"./tax_saving.svg": 3098,
	"./taxfiling_1.svg": 3099,
	"./taxfiling_banner.svg": 3100,
	"./taxfiling_banner1.svg": 3101,
	"./taxwin.svg": 3102,
	"./tech_fund.svg": 1728,
	"./term_ins_system_maintenance.svg": 1729,
	"./terms_agree.png": 3432,
	"./text_error_icon.svg": 1136,
	"./text_investments.svg": 3103,
	"./thumb.svg": 940,
	"./thumb_down.svg": 3104,
	"./thumb_down_fill.svg": 3105,
	"./thumb_up.svg": 3106,
	"./thumb_up_fill.svg": 3107,
	"./thumpsup.png": 3433,
	"./tmb.png": 3562,
	"./tmb.svg": 3108,
	"./tool.svg": 3109,
	"./track_gold_icon@2x.png": 3563,
	"./train.png": 3434,
	"./trans_icon.png": 3564,
	"./transaction_summary.svg": 3110,
	"./transparency.svg": 3111,
	"./trending_heart_icon.png": 3435,
	"./trust_icon_contact.svg": 3112,
	"./trust_icon_emandate.svg": 3113,
	"./trust_icon_secure.svg": 3114,
	"./trust_icons.svg": 3115,
	"./trust_icons_emandate.svg": 1137,
	"./tvs.png": 3565,
	"./tvs.svg": 3116,
	"./tvscredit.svg": 3117,
	"./two_tap_icn@4x.png": 3566,
	"./ubi.svg": 3118,
	"./ubiweb.png": 3567,
	"./ucomb.svg": 3119,
	"./ucomb_bank.svg": 3120,
	"./unfortunate_events_fisdom.svg": 3121,
	"./unfortunate_events_myway.svg": 3122,
	"./union.svg": 997,
	"./up_arrow.svg": 515,
	"./upcoming_sip.svg": 1730,
	"./update_insurance_fisdom.svg": 998,
	"./updating_shortly.svg": 999,
	"./upi_apps.svg": 1138,
	"./vacation.svg": 3123,
	"./vacation_icon.png": 3436,
	"./value_for_money_icon.png": 3437,
	"./view_all.svg": 3124,
	"./view_more.svg": 3125,
	"./wait_icn.png": 3568,
	"./wallet_icon.svg": 1139,
	"./warning_icon.svg": 1731,
	"./web_icon_1.png": 1140,
	"./web_icon_2.png": 1141,
	"./web_icon_3.png": 1142,
	"./web_icon_4.png": 1143,
	"./wedding_icon.png": 3438,
	"./whatsapp.svg": 1144,
	"./withdraw.png": 718,
	"./withdraw_anytime_icn.png": 3569,
	"./withdraw_anytime_icon.png": 3439,
	"./withdraw_funds.svg": 3126,
	"./xls_icon.svg": 3127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;